import React from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import { bindActionCreators } from "redux";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import * as _ from "lodash";
import PropTypes from "prop-types";
import { Auth } from "aws-amplify";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
import * as Modal from "react-modal";
import { Icon } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import ReactTable from "react-table";
import transcard from "../../images/transcard.png";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Tab1 from "@material-ui/core/Tab";
import TabContext1 from "@material-ui/lab/TabContext";
import TabList1 from "@material-ui/lab/TabList";
import TabPanel1 from "@material-ui/lab/TabPanel";
import LinkAccountStep1 from "../../components/profile/linkAccountStepOne.js";
import LinkAccountStep2 from "../../components/profile/linkAccountStepTwo.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CardInputMaskinking from "../common/cardInputMaskinking";
import CardInputField from "../common/cardInputField";
import LinkCardAccountAddress from "../../components/profile/linkCardAccountAddress.js";
// import { confirmAlert } from 'react-confirm-alert';
import { CSVLink,} from "react-csv";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import {
  ToastsContainer,
  ToastsStore,
  ToastsContainerPosition,
} from "react-toasts";
import ChangePassword from "../common/changePassword";

import SubuserUpdateBusiness from "../affiliateComponents/subuserBusiness/subuserUpdateBusiness";

import MaskInputNumber from "../common/maskInputNumberProfile";
import MaskInputEinNumber from "../common/maskInputEinNumberProfile";

import "react-toastify/dist/ReactToastify.css";
import loader from "../../images/Spin-1s-107px.gif";
import CustomSignature from "../common/signatureComponent";
import {
  updateBusinessUser,
  getAllCountry,
  updateBusinessCompany,
  updateBusinessCompanyData,
  uploadfile,
  getAllChildCompanyProfile,
  viewCompanyChildRecord,
  deleteCompanyChildRecord,
  getCityByStateId,
  getBusinessUser,
  disbursePayment,
  getBusiness,
  getIndustry,
  getAllStates,
  getTranscardPaymentMethods,
  postUploadChildCompany,
  getAllBusinessSubUsers,
  checkEmailVerify,
  clearDataEmail,
  getDebitWalletBalance,
  createTranscardAccount,
  getAddedBankAccountsForUser,
  getCollectedSettlementsHistoryForUser,
  getAllBankAccountsForUser,
  getUserTransactionsHistory,
  addUserBankAccount,
  transferFundsToACH,
  transferFundsToCard,
  clearReceiveAddUserBankAccountApi,
  setDefaultBankAccount,
  deleteUserBankAccount,
  showNetAmountToUser,
  updateBankAccountDetails,
  clearReceiveTransferFundsToACH,
  cleargetDebitWalletBalance,
  clearRecieveDisburseAmount,
  createTranscardCard,
  addBusinessUserCard,
  clearReceiveAddBusinessUserCard,
  clearReceiveUpdateBankAccountDetails,
  clearReceiveUpdateCardDetails,
  getAddedCardsForUser,
  updateCardDetails,
  deleteUserCard,
  getAllAddedCardsForUser,
  setDefaultCard,
} from "../../Actions/actions";
import xlsxFile from "../../files/childCompany.xlsx";
import csvFile from "../../files/childCompany.csv";
import lockImage from "../../images/lock.png";
import UploadFilesGroup from "../common/UploadFilesGroup";
import TextFieldGroup from "../common/TextFieldGroupProfile";
import BannerHead from "../BannerHead";
// import DownloadPdf from "../../components/downloadPdf"
import DownloadPdfFile from "./downloadPDFFile";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    height: "654px",
    padding: "0",
    border: "none",
  },
};

const customStylesTransferType = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "unset",
    height: "370px",
    padding: "0",
    border: "0",
    width: "460px",
  },
};

const customStylesCardDetails = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    height: "450px",
    padding: "0",
    border: "none",
  },
};

const customStylesConfirmationPopup = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    minHeight: "307px",
    padding: "0",
    border: "none",
  },
};

const customEditStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    height: "auto",
    padding: "0",
    border: "none",
  },
};

const linkedAccCustomStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "700px",
    height: "550px",
  },
};
const customStylesDisburse = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "unset",
    height: "490px",
    padding: "0",
    border: "0",
    width: "460px",
  },
};

const customCompanyStyles = {
  content: {
    top: "10%",
    left: "30%",
    right: "auto",
    bottom: "auto",
    overflow: "scroll",
  },
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      modalIsDebite: false,
      firstName: "",
      lastName: "",
      companyTitle: "",
      mobilePhone: "",
      workPhoneNumber: "",
      email: "",
      companyName: "",
      streeAddress: "",
      city: "",
      state: "",
      stateName: "",
      zipCode: "",
      separateTaxId: "",
      enterpriseType: "s",
      startingYear: "",
      webSite: "",
      industryTypeId: "",
      cIndustryTypeId: "",
      taxId: "",
      bankruptcyStatus: "",
      dissolvedStatus: "",
      acceptCC: "",
      planId: 0,
      isLoading: false,
      businessTypeId: "",
      cBusinessTypeId: "",
      roleName: "Business-User",
      readDisclaimer: "",
      readPrivacyPolicy: "",
      readLetterOfAgency: "",
      readUserAgreement: "",
      since: "",
      errors: {},
      cErrors: {},
      totalTaxId: "",
      companyInformation: [],
      stateSuccess: [],
      ChidCompanyDataSuccess: true,
      modalIsOpen: false,
      file: "",
      CompanyForm: false,
      cCompanyName: "",
      cStreeAddress: "",
      cCity: "",
      cState: "",
      cZipCode: "",
      cSeparateTaxId: 0,
      cStartingYear: "",
      cOtherIndustryType: "",
      cWebSite: "",
      cTaxId: "",
      cDissolvedStatus: "",
      cBankruptcyStatus: "",
      cAcceptCC: "",
      uploadDoc: "",
      updateImage: true,
      recordsCompany: [],
      saveChildStatus: true,
      deleteChildStatus: true,
      data: "",
      viewUpdate: "",
      showButton: true,
      SaveChildStatus: true,
      UpdateChildStatus: true,
      cityId: "",
      stateId: "",
      countryCode: "+1",
      workCountryCode: "+",
      BusinessUpdateUserProfileData1: [],
      successUpdateProfileState: false,
      UpdateChidCompanyDataState: false,
      saveChidCompanyDataState: false,
      showUpadeButtonR: true,
      showButton1: false,
      isLoader: false,
      ChidCompanyData1: [],
      SaveChidCompanyData1: [],
      modalIsOpenSubUserDelete: false,
      deleteSubUserid: "",
      signatureDefaultValue: "",
      signatureFontFamily: "",
      privacyPolicyPath: "",
      agreementLetterPath: "",
      letterOfAgencyPath: "",
      uploadForm: false,
      uploadedChild: [],
      pageNumber: 0,
      pageSize: 10,
      uploadCsvFile: {},
      errorsFile: {},
      oldEmail: "",
      intervalId: 0,
      cContactName: "",
      cContactEmail: "",
      cContactNumber: "",
      cEin: "",
      cEntityName: "",
      streeAddress2: "",
      otherIndustryType: "",
      linkAccountStep1: false,
      value: "1",
      cardValue: "1",
      checkboxState: false,
      routingNumber: "",
      accountNumber: "",
      accountType: "",
      accountHolderName: "",
      displayName: "",
      createAccEnable: false,
      transcardAccountState: false,
      accountHolderNameError: "",
      accountNumberError: "",
      routingNumberError: "",
      tableState :false,
      displayNameError: "",
      showLinkButton: false,
      disburseAmountPopupState: false,
      transferFundsToACHState: false,
      transferFundsToCardState: false,
      debitWalletBalanceState: false,
      addUserBankAccountState: false,
      addMultipleAccountState: false,
      addAccountStep1: false,
      isCreated: false,
      isCreatedCard: false,
      viewAccountState: false,
      openEditModel: false,
      AddNewBankAccountState: true,
      radioAccountValue: "",
      addNewAccWithoutAdd: "",
      noAccountLinked: false,
      showDeleteConfirmation: false,
      hasAnyActiveAccount: false,
      userHasNoAccounts: false,
      userHasNoCards: false,
      hasAnyActiveCard: false,
      accountTypePopupState: false,
      addBusinessUserCardState: false,
      achState: false,
      radioAddedCardChecked: false,
      instantTransferState: false,
      cardLastName: "",
      cardFirstName: "",
      cardNickName: "",
      radioAddedAccountChecked:false,
      clickedcheckButton : false,
      cardErrors: {
        cardMonthError: true,
        cardNumberError: true,
      },
      cardErrorsState: {
        cardMonthError: true,
        cardNumberError: true,
      },
      cardAlreadyLinked: false,
      addNewCardWithoutAdd: "",
      transcardCardState: false,
      noCardLinked: false,
    };
    this.onChange = this.onChange.bind(this);
    this._onSelect = this._onSelect.bind(this);
    this._conSelect = this._conSelect.bind(this);
    this._onSelectForBusiness = this._onSelectForBusiness.bind(this);
    this._conSelectForBusiness = this._conSelectForBusiness.bind(this);
    this._conSelectForYears = this._conSelectForYears.bind(this);
    this._onSelectForYears = this._onSelectForYears.bind(this);
    this.handleSubmitBusiness = this.handleSubmitBusiness.bind(this);
    this.handleSubmitCompanyChild = this.handleSubmitCompanyChild.bind(this);
    this.handleSeletcedYearChangeConsumer = this.handleSeletcedYearChangeConsumer.bind(
      this
    );
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openCompanyForm = this.openCompanyForm.bind(this);
    this.closeCompanyForm = this.closeCompanyForm.bind(this);
    this.openUploadForm = this.openUploadForm.bind(this);
    this.closeUploadForm = this.closeUploadForm.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.uploadChildCompnayCsv = this.uploadChildCompnayCsv.bind(this);
    this.uploadSignature = this.uploadSignature.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this._countrySelectWork = this._countrySelectWork.bind(this);
    this._cSince1 = this._cSince1.bind(this);
    this._cSince2 = this._cSince2.bind(this);
    this.closeModalSubUserDelete = this.closeModalSubUserDelete.bind(this);
    this.handleUpdateCompanyChild = this.handleUpdateCompanyChild.bind(this);
    this.handleDeleteYSubuser = this.handleDeleteYSubuser.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
    this.onChangeTaxId = this.onChangeTaxId.bind(this);
  }

  sigPad = {};

  clear = () => {
    this.sigPad.clear();
  };

  trim = () => {
    const { firstName, lastName, email, streeAddress } = this.state;
    if (this.sigPad.isEmpty() === false) {
      this.props.uploadfile({
        image: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
        firstName,
        lastName,
        email,
        streeAddress,
      });
      this.setState({
        file: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
        updateImage: false,
      });
    }
    this.closeModal();
  };

  finalSubmit = (data) => {
    const { firstName, lastName, email, streeAddress } = this.state;
    this.props.uploadfile({
      image: data.file,
      firstName,
      lastName,
      email,
      streeAddress,
    });
    this.setState({
      file: data.file,
      updateImage: false,
      modalIsOpen: false,
      signatureDefaultValue: data.signatureVlaue,
    });
  };

  uploadSignature() {
    this.props.uploadfile(this.state);
    this.setState({ updateImage: true });
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value, cErrors: {}, errors: {} });
  }

  _countrySelectWork(e) {
    this.setState({ workCountryCode: e.value, cErrors: {}, errors: {} });
  }

  _cSince1(e) {
    this.setState({ startingYear: e.value, errors: {}, cErrors: {} });
  }

  _cSince2(e) {
    this.setState({ cStartingYear: e.value, errors: {}, cErrors: {} });
  }

  openModal() {
    this.setState({
      modalIsOpen: true,
    });
  }

  deleteCompanyChild(id) {
    this.setState({ modalIsOpenSubUserDelete: true, deleteSubUserid: id });
  }

  /**
   * View Company Childs
   * @param {number} id
   * @param {status} viewStatus
   */
  viewCompanyChild(id, viewStatus) {
    this.props.viewCompanyChildRecord(id);
    this.setState({
      viewUpdate: viewStatus,
      CompanyForm: true,
      cErrors: {},
      errors: {},
    });
    if (viewStatus === "view") {
      this.setState({ showButton: false });
    } else {
      this.setState({
        showUpadeButtonR: true,
        showButton1: false,
        cErrors: {},
        errors: {},
      });
    }
  }

  /**
   * Submut Company Child Form
   */
  handleSubmitCompanyChild(e) {
    e.preventDefault();
    if (this.isValidBusinessCompany()) {
      this.setState({
        cErrors: {},
        isLoader: true,
        isLoader: true,
        saveChidCompanyDataState: true,
        SaveChildStatus: true,
        UpdateChildStatus: true,
      });
      this.props.updateBusinessCompany(this.state);
    }
  }

  handleUpdateCompanyChild(e) {
    e.preventDefault();
    if (this.isValidBusinessCompany()) {
      this.setState({
        cErrors: {},
        isLoading: true,
        isLoader: true,
        UpdateChidCompanyDataState: true,
        SaveChildStatus: true,
        UpdateChildStatus: true,
      });
      this.props.updateBusinessCompanyData(this.state);
    }
  }

  closeModalSubUserDelete() {
    this.setState({ modalIsOpenSubUserDelete: false, deleteSubUserid: "" });
  }

  /**
   * Delete Sub user
   */
  handleDeleteYSubuser() {
    const data = {
      id: this.state.deleteSubUserid,
      pId: this.state.companyProfileId,
    };
    this.props.deleteCompanyChildRecord(data);
    this.setState({
      modalIsOpenSubUserDelete: false,
      deleteSubUserid: "",
      deleteChildStatus: true,
      isLoader: true,
    });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  /**
   * Open Company Form
   */
  openCompanyForm() {
    this.setState({
      CompanyForm: true,
      cCompanyName: "",
      cIndustryTypeId: "",
      cStreeAddress: "",
      cCity: "",
      cState: "",
      cZipCode: "",
      cSeparateTaxId: 0,
      cStartingYear: "",
      cOtherIndustryType: "",
      cWebSite: "",
      cTaxId: "",
      cDissolvedStatus: "",
      cBankruptcyStatus: "",
      cAcceptCC: "",
      showButton: true,
      errors: "",
      cContactName: "",
      cContactEmail: "",
      cContactNumber: "",
      cEin: "",
      cEntityName: "",
      viewUpdate: "",
      showButton1: true,
      showUpadeButtonR: false,
    });
  }

  closeCompanyForm() {
    this.setState({
      CompanyForm: false,
      uploadFile: "",
      errorsFile: {},
    });
  }

  /**
   * Open Upload csv Form
   */

  openUploadForm() {
    this.setState({
      uploadForm: true,
    });
  }

  /**
   * Close Upload Form
   */

  closeUploadForm() {
    this.setState({
      uploadForm: false,
      uploadCsvFile: {},
      errorsFile: {},
    });
  }

  /**
   * Handel Upload File
   */

  handleChangeFile(event) {
    if (
      event.target.files[0].name.split(".").pop() === "xlsx" ||
      event.target.files[0].name.split(".").pop() === "csv"
    ) {
      this.setState({
        uploadCsvFile: event.target.files[0],
        errorsFile: {},
      });
    } else {
      this.setState({
        errorsFile: {
          file: "Please upload xlsx or csv file only!",
          fileError: true,
        },
      });
    }
  }

  uploadChildCompnayCsv() {
    const { uploadCsvFile } = this.state;

    const formData = new FormData();
    const file = uploadCsvFile;
    formData.append("file", file);
    formData.append("userId", localStorage.getItem("userId"));
    if (file.size > 1) {
      this.setState({
        isLoader: true,
        uploadForm: false,
      });
      this.props.postUploadChildCompany(formData);
    } else {
      this.setState({
        errorsFile: {
          file: "Please upload xlsx or csv file only!",
          fileError: true,
        },
      });
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value, errors: {} });
    if (e.target.name === "separateTaxId") {
      if (e.target.value === "no") {
        this.setState({ totalTaxId: 0 });
      } else {
        this.setState({ totalTaxId: 1 });
      }
    }
  }

  onChangeTaxId(e) {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value === "") {
      if (Number.parseInt(e.target.value, 10) !== 0 || e.target.value === "") {
        this.setState({
          [e.target.name]: e.target.value,
          errors: {},
          errorsTermPolicy: {},
          errorsCompany: {},
        });
      }
    }
  }

  _cSelect(e) {
    this.setState({ state: e.value });
  }

  componentDidMount() {
    this.setState({ isMounted: true }, () => {
      if (this.state.isMounted) {
        this.setState({ isMounted: false });
        {
          const dataB = {
            lookupTypeId: 1,
          };
          const dataI = {
            lookupTypeId: 2,
          };
          this.props.getAllCountry();
          this.props.getAddedBankAccountsForUser(
            localStorage.getItem("userId")
          );
          this.props.getUserTransactionsHistory(localStorage.getItem("userId"));
          this.props.getCollectedSettlementsHistoryForUser(
            localStorage.getItem("userId")
          );
          this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
          this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
          this.props.getAllStates();
          this.props.getBusiness(dataB);
          this.props.getIndustry(dataI);
          this.props.getTranscardPaymentMethods();
          this.props.getAddedCardsForUser(localStorage.getItem("userId"));
        }
      }
    });
    // this.props.getAllStates();
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  handleCheckBoxFirstStep = () => {
    if (this.state.checkboxState == false) {
      this.setState({
        checkboxState: true,
      });
    } else {
      this.setState({
        checkboxState: false,
      });
    }
  };

  debitWalletBalance = async () => {
    const { getDebitWalletBalance } = this.props;
    const { walletBalance, userId, roleName } = this.state;
    this.setState({
      isLoader: true,
      modalIsDebite: false,
    });
    await getDebitWalletBalance({
      userId,
      debitedAmount: walletBalance,
      transferMode: this.state.transcardAccountState
        ? "ACH"
        : "Instant Transfer",
      roleName,
    });
    await this.props.getBusinessUser(localStorage.getItem("userId"));
    await this.props.getCollectedSettlementsHistoryForUser(
      localStorage.getItem("userId")
    );
  };

  afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  };

  closeModalResidences = () => {
    this.setState({
      linkAccountStep1: false,
      addAccountStep1: false,
      viewAccountState: false,
      addMultipleAccountState: false,
      openEditModel: false,
      bankAccountConfirmationPopup: false,
      cardButtonStepActive: false,
      cardFirstName: "",
      cardFirstNameError: false,
      cardLastName: "",
      cardLastNameError: false,
      cardNickName: "",
      cardNickNameError: false,
      cardNumber: "",
      cardNumberError: false,
      cardMonth: "",
      cardMonthError: false,
      cardYear: "",
      cardYearError: false,
      cardCvv: "",
      cardCvvError: false,
      achState: false,
      instantTransferState: false,
      openEditCardModel: false,
      bankCardConfirmationPopup: false,
      radioAddedCardChecked: false,
      radioCardValue: "",
      radioAccountValue: "",
    });
  };

  closeModalDebite = () => {
    this.setState({
      modalIsDebite: false,
    });
  };

  debitAlert = (e) => {
    e.preventDefault();
    this.setState({
      modalIsDebite: true,
    });
  };

  accountTypePopup = () => {
    this.setState({
      accountTypePopupState: true,
    });
  };

  openAccountTypePopup = () => {
    this.setState({
      accountTypePopupState: true,
    });
  };

  closeAccountTypePopup = () => {
    this.setState({
      accountTypePopupState: false,
      modalIsOpenResidences: false,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
      viewAccountState: false,
      addAccountStep1: false,
      addCardAccountStep1: false,
      saveAddress: false,
      openEditModel: false,
      bankAccountConfirmationPopup: false,
      nextButtonStepActive: false,
      nextCardButtonStepActive: false,
      achState: false,
      instantTransferState: false,
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
      openEditCardModel: false,
    });
  };

  handleSubmitTransferType = (e) => {
    e.preventDefault();
    if (this.state.achState) {
      this.setState({
        accountTypePopupState: false,
        cardButtonStepActive: false,
      });
      if (this.state.userHasNoAccounts == true) {
        this.linkAccountPopup("addNewLinkAccount");
      }
      if (this.state.userHasNoAccounts == false) {
        this.addedBankReviewPopup();
      }
    } else {
      this.setState({
        accountTypePopupState: false,
        // cardButtonStepActive: true,
      });
      if (this.state.userHasNoCards == true) {
        this.linkCardPopup("addNewLinkCard");
      }
      if (this.state.userHasNoCards == false) {
        this.addedCardReviewPopup();
      }
    }
  };

  onTransferCheck = (e) => {
    if (e.target.value == "ach") {
      this.setState({
        achState: true,
        instantTransferState: false,
      });
    } else {
      this.setState({
        instantTransferState: true,
        achState: false,
      });
    }
  };

  componentWillMount() {
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.props.getBusinessUser(localStorage.getItem("userId"));
    this.props.getAllBusinessSubUsers();
    Auth.currentUserInfo()
      .then((res) => {
        this.setState({
          readDisclaimer: res.attributes["custom:readDisclaimer"],
          readPrivacyPolicy: res.attributes["custom:readPrivacyPolicy"],
          readLetterOfAgency: res.attributes["custom:readLetterOfAgency"],
          readUserAgreement: res.attributes["custom:readUserAgreement"],
        });
        const Fname = res.attributes["custom:first_name"];
        const Lname = res.attributes["custom:last_name"];
        const name = `${Fname} ${Lname}`;
        this.setState({ UserName: name });
      })
      .catch((error) => error);
    this.setState({
      intervalId,
    });
  }

  _onSelect(e) {
    this.setState({ state: e.value, errors: {}, cErrors: {} });
    this.setState({ stateName: e.label });
  }

  _conSelect(e) {
    this.setState({ cState: e.value, errors: {}, cErrors: {} });
  }

  _onSelectForBusiness(e) {
    this.setState({ businessTypeId: e.value, errors: {}, cErrors: {} });
  }

  _conSelectForBusiness(e) {
    this.setState({ cBusinessTypeId: e.value, errors: {}, cErrors: {} });
  }

  _onSelectForYears(e) {
    this.setState({
      industryTypeId: e.value,
      otherIndustryType: "",
      errors: {},
      cErrors: {},
    });
  }

  _conSelectForYears(e) {
    this.setState({
      cIndustryTypeId: e.value,
      cOtherIndustryType: "",
      errors: {},
      cErrors: {},
    });
  }

  verifyEmail() {
    if (this.state.email !== "") {
      this.props.checkEmailVerify({ email: this.state.email });
    }
  }

  validate = () => {
    // let accountHolderNameError= "";
    let accountNumberError = "";
    let routingNumberError = "";
    let accountTypeError = "";
    // let displayNameError= "";

    if (this.state.routingNumber.length != 9 && this.state.routingNumber > 0) {
      routingNumberError = "Please fill 9 digit routing number";
    }

    if (!this.state.accountType) {
      accountTypeError = "Please select account type";
    }

    if (this.state.accountNumber.length != 12) {
      accountNumberError = "Please fill 12 digit account number";
    }

    if (accountNumberError || routingNumberError || accountTypeError) {
      this.setState({
        routingNumberError,
        accountNumberError,
        accountTypeError,
      });
      return false;
    }
    return true;
  };

  createAccountCard = () => {
    let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
    const data = {
      userId: localStorage.getItem("userId"),
      cvc: this.state.cardCvv,
      firstName: this.state.cardFirstName,
      lastName: this.state.cardLastName,
      cardNumber: this.state.cardNumber.replace(/_/g, "").replace(/ /g, ""),
      cardNickName: this.state.cardNickName,
      cardExpirationDate: cardExpirationDate,
      streeAddress: this.state.address1CardPopup,
      streetAddress2: this.state.address2CardPopup,
      city: this.state.cityCardPopup,
      zipCode: this.state.zipCardPopup,
      stateId: this.state.stateCardPopup,
    };
    this.setState({
      isLoader: true,
      transcardCardState: true,
    });

    this.props.createTranscardCard({ data });
  };

  AddMultipleCard = async () => {
    this.setState({
      isLoader: true,
      addBusinessUserCardState: true,
    });
    let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
    const data = {
      userId: localStorage.getItem("userId"),
      cvc: this.state.cardCvv,
      firstName: this.state.cardFirstName,
      lastName: this.state.cardLastName,
      cardNumber: this.state.cardNumber.replace(/_/g, "").replace(/ /g, ""),
      cardNickName: this.state.cardNickName,
      cardExpirationDate: cardExpirationDate,
    };
    await this.props.addBusinessUserCard({ data });
  };

  handlePopupSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (
      isValid &&
      this.state.addMultipleAccountState != true &&
      this.state.addNewAccWithoutAdd == ""
    ) {
      this.createAccount();
    }
    if (
      isValid &&
      (this.state.addNewAccWithoutAdd == "addNewAccount" ||
        this.state.addMultipleAccountState == true)
    ) {
      this.AddMultipleAccount();
    }
    // if (isValid && this.state.addMultipleAccountState == true) {
    //   this.AddMultipleAccount ();
    // }
  };

  handleCardPopupSubmit = (e) => {
    e.preventDefault();
    if (this.state.addNewCardWithoutAdd == "") {
      this.createAccountCard();
    }
    // if (this.state.addNewCardWithoutAdd == "addNewCard") {
    //   this.AddMultipleAccount();
    // }
    // if (this.state.addMultipleAccountState == true) {
    //   this.AddMultipleAccount();
    // }
  };

  handleCardPopupAlreadyLinkedSubmit = (e) => {
    // e.preventDefault();
    // if (this.state.addNewCardWithoutAdd == "") {
    //   this.createAccountCard();
    // }
    this.AddMultipleCard();
    // if (this.state.addNewCardWithoutAdd == "addNewCard") {
    //   this.AddMultipleAccount();
    // }
    // if (this.state.addMultipleAccountState == true) {
    //   this.AddMultipleAccount();
    // }
  };

  onChangeStep2 = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        let {
          accountHolderName,
          accountNumber,
          routingNumber,
          displayName,
          accountType,
        } = this.state;
        if (accountHolderName == "") {
          this.setState({
            accountHolderNameError: true,
          });
        }
        if (accountType == "") {
          this.setState({
            accountTypeError: true,
          });
        }
        if (accountNumber == "") {
          this.setState({
            accountNumberError: true,
          });
        }
        if (routingNumber == "") {
          this.setState({
            routingNumberError: true,
          });
        }
        if (displayName == "") {
          this.setState({
            displayNameError: true,
          });
        }
        if (
          accountHolderName != "" &&
          accountNumber != "" &&
          routingNumber != "" &&
          displayName != "" &&
          accountType != ""
        ) {
          this.setState({
            createAccEnable: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
          });
        }
      }
    );
  };

  onChangeStep2Select = (accountType) => {
    this.setState(
      {
        accountType,
      },
      () => {
        let {
          accountHolderName,
          accountNumber,
          routingNumber,
          displayName,
          accountType,
        } = this.state;
        if (accountHolderName == "") {
          this.setState({
            accountHolderNameError: true,
          });
        }
        if (accountType == "") {
          this.setState({
            accountTypeError: true,
          });
        }
        if (accountNumber == "") {
          this.setState({
            accountNumberError: true,
          });
        }
        if (routingNumber == "") {
          this.setState({
            routingNumberError: true,
          });
        }
        if (displayName == "") {
          this.setState({
            displayNameError: true,
          });
        }
        if (
          accountHolderName != "" &&
          accountNumber != "" &&
          routingNumber != "" &&
          displayName != "" &&
          accountType != ""
        ) {
          this.setState({
            createAccEnable: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
          });
        }
      }
    );
  };

  onChange(e) {
    this.setState(
      {
        [e.target.name]: e.target.value,
        errors: {},
        errorsResidence: {},
        errorsCompany: {},
      },
      () => {
        if (this.state.cEmail !== "") {
          this.props.checkEmailVerify({ email: this.state.cEmail });
        }
      }
    );
  }

  onChangeEditAccount = (e) => {
    if (e.target.value.length <= 0) {
      this.setState({
        [e.target.name]: e.target.value,
        errorbankName: true,
        updateBankButton: false,
      });
    } else {
      this.setState({
        ...this.state.bankName,
        bankName: e.target.value,
        errorbankName: false,
        updateBankButton: true,
      });
    }
  };

  accountNameChange = (e) => {
    if(this.state.radioAddedAccountChecked===false){
      this.setState({
        radioAddedAccountChecked: true,
        radioAccountValue: e.target.value,
      });
    }
      if(this.state.radioAddedAccountChecked){
      this.setState({radioAddedAccountChecked:false,
      radioAccountValue:""})
    }
    // this.setState({
    //   radioAddedAccountChecked: true,
    //   radioAccountValue: e.target.value,
    // });
  };

  // accountNameChange = (e) => {
  //   if(this.state.radioAddedAccountChecked===false){
  //   this.setState({
  //     radioAddedAccountChecked: true,
  //     radioAccountValue: e.target.value,
  //   });
  // }
  //   if(this.state.radioAddedAccountChecked){
  //   this.setState({radioAddedAccountChecked:false,
  //   radioAccountValue:""})
  // }

  // dualChange = () => {
  //   {console.log("clickedcheckButton",this.state.clickedcheckButton)}
  //   const doClick = {...this.state.clickedcheckButton};
  //   this.setState({
  //     clickedcheckButton: !doClick
  //   });
  // }


  cardNameChange = (e) => {
    if(this.state.radioAddedCardChecked===false){
      this.setState({
        radioAddedCardChecked: true,
        radioCardValue: e.target.value,
      });
    }
      if(this.state.radioAddedCardChecked){
        this.setState({radioAddedCardChecked: false,
        radioCardValue: ""})
    }
    // this.setState({
    //   radioAddedCardChecked: true,
    //   radioCardValue: e.target.value,
    // });
  };

  validateCardAddress = () => {
    let zipCardPopupError = "";
    let address1CardPopupError = "";
    let cityCardPopupError = "";

    if (this.state.zipCardPopup && this.state.zipCardPopup.length < 5) {
      zipCardPopupError = "Please fill 5 digit zip code";
    }

    if (
      this.state.address1CardPopup &&
      (this.state.address1CardPopup.length < 2 ||
        this.state.address1CardPopup.length > 50)
    ) {
      address1CardPopupError = "Please fill 2 to 50 characters";
    }

    if (
      this.state.cityCardPopup &&
      (this.state.cityCardPopup.length < 2 ||
        this.state.cityCardPopup.length > 30)
    ) {
      cityCardPopupError = "Please fill 2 to 30 characters in city";
    }

    if (zipCardPopupError || address1CardPopupError || cityCardPopupError) {
      this.setState({
        zipCardPopupError,
        address1CardPopupError,
        cityCardPopupError,
        nextCardButtonStepActive: false,
      });
      return false;
    }
    this.setState({
      nextCardButtonStepActive: true,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
    });
    return true;
  };

  onChangeCardAddress = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        let {
          address1CardPopup,
          address2CardPopup,
          cityCardPopup,
          zipCardPopup,
          stateCardPopup,
          stateCardPopupName,
        } = this.state;
        if (address1CardPopup == "") {
          this.setState({
            address1CardPopupError: true,
          });
        }
        if (stateCardPopup == "" || stateCardPopupName == "State") {
          this.setState({
            stateCardPopupError: true,
            addressCardNextButton: false,
          });
        }
        if (address2CardPopup == "") {
          this.setState({
            address2CardPopupError: true,
          });
        }
        if (cityCardPopup == "") {
          this.setState({
            cityCardPopupError: true,
          });
        }
        if (zipCardPopup == "") {
          this.setState({
            zipCardPopupError: true,
          });
        }
        if (
          address1CardPopup != "" &&
          cityCardPopup != "" &&
          zipCardPopup != "" &&
          stateCardPopupName != "State" &&
          stateCardPopup != ""
        ) {
          this.setState({
            addressCardNextButton: true,
          });
        } else {
          this.setState({
            addressCardNextButton: false,
          });
        }
      }
    );
  };

  onChangeCardAddressSelect = (stateCardPopup, stateCardPopupName) => {
    console.log("stateCardPopupName", stateCardPopupName);
    this.setState(
      {
        stateCardPopup,
        stateCardPopupName,
      },
      () => {
        let {
          address1CardPopup,
          address2CardPopup,
          cityCardPopup,
          zipCardPopup,
          stateCardPopup,
          stateCardPopupName,
        } = this.state;

        if (address1CardPopup == "") {
          this.setState({
            address1CardPopupError: true,
          });
        }
        if (stateCardPopup == "" || stateCardPopupName == "State") {
          this.setState({
            stateCardPopupError: true,
            addressCardNextButton: false,
          });
        }
        if (address2CardPopup == "") {
          this.setState({
            address2CardPopupError: true,
          });
        }
        if (cityCardPopup == "") {
          this.setState({
            cityCardPopupError: true,
          });
        }
        if (zipCardPopup == "") {
          this.setState({
            zipCardPopupError: true,
          });
        }
        if (
          address1CardPopup != "" &&
          cityCardPopup != "" &&
          zipCardPopup != "" &&
          stateCardPopupName != "State" &&
          stateCardPopup != ""
        ) {
          this.setState({
            createAccEnable: true,
            addressCardNextButton: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
            addressCardNextButton: false,
          });
        }
      }
    );
  };

  handleSubmitNextAddress = (e) => {
    e.preventDefault();
    let isValid = this.validateAddress();
    if (isValid) {
      this.setState({
        value: "3",
        address1PopupError: "",
        cityPopupError: "",
        statePopupError: "",
        zipPopupError: "",
      });
    }
  };

  handleSubmitNextCardAddress = (e) => {
    e.preventDefault();
    let isValid = this.validateCardAddress();
    if (isValid) {
      this.setState({
        cardValue: "3",
        address1CardPopupError: "",
        cityCardPopupError: "",
        stateCardPopupError: "",
        zipCardPopupError: "",
        // addCardAccountStep1: true
      });
    }
  };

  onChangeEditCard = (e) => {
    if (e.target.value.length <= 0) {
      this.setState({
        [e.target.name]: e.target.value,
        errorCardName: true,
        updateCardButton: false,
      });
    } else {
      this.setState({
        ...this.state.cardNickName,
        cardNickName: e.target.value,
        errorCardName: false,
        updateCardButton: true,
      });
    }
  };

  changeBankNickName = () => {
    this.setState({
      isLoader: true,
      errorbankName: false,
    });
    const data = {
      userId: localStorage.getItem("userId"),
      bankAccountId: this.state.bankId,
      accountDisplayName: this.state.bankName,
    };
    this.props.updateBankAccountDetails({ data });
  };

  changeCardNickName = () => {
    this.setState({
      isLoader: true,
      errorCardName: false,
    });
    const data = {
      userId: localStorage.getItem("userId"),
      cardId: this.state.cardId,
      cardNickName: this.state.cardNickName,
    };
    this.props.updateCardDetails({ data });
  };

  cancelEditModel = () => {
    this.setState({
      openEditModel: false,
      openEditCardModel: false,
    });
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  handleAlreadyAddedCard = (e) => {
    e.preventDefault();
    const data = {
      cardId: this.state.radioCardValue,
      userId: localStorage.getItem("userId"),
    };

    this.props.setDefaultCard({ data });
    this.setState({
      bankCardConfirmationPopup: false,
      radioAddedCardChecked: true,
    });
    // this.setDefaultBankAccount
  };

  handleAlreadyAddedAccount = (e) => {
    e.preventDefault();
    const data = {
      bankAccountId: this.state.radioAccountValue,
      userId: localStorage.getItem("userId"),
    };

    this.props.setDefaultBankAccount({ data });
    this.setState({
      bankAccountConfirmationPopup: false,
      radioAddedAccountChecked: true,
    });
    // this.setDefaultBankAccount
  };
  // Validate Card Details

  onChangeCarad = (e) => {
    let labelName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value.trimLeft(),
      },
      () => {
        this.isValidCardDetail(labelName);
      }
    );
  };

  isValidCardDetail(label) {
    const { errors, errorsState, isValid } = this.validateInputCard(
      this.state,
      label
    );
    // console.log('errors')
    // if (!isValid) {
    this.setState({ cardErrors: errors, cardErrorsState: errorsState });
    // }
    return isValid;
  }

  validateInputCard(data, label) {
    const { cardErrorsState } = this.state;
    const errors = cardErrorsState;
    const d = new Date();

    // const scrollViews = [];
    switch (label) {
      case "cardNumber":
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber =
            "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }
        break;

      case "cardFirstName":
        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        } else if (
          data.cardFirstName.length < 2 ||
          data.cardFirstName.length > 20
        ) {
          errors.cardFirstName =
            "First name should consist of min 2 and max 20 characters";
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }
        break;
      case "cardNickName":
        if (Validator.isEmpty(data.cardNickName)) {
          errors.cardNickName = "Nick Name is required";
          errors.cardNickNameError = true;
        } else if (
          data.cardNickName.length < 2 ||
          data.cardNickName.length > 20
        ) {
          errors.cardNickName =
            "Nick name should consist of min 2 and max 20 characters";
          errors.cardNickNameError = true;
        } else {
          errors.cardNickName = "";
          errors.cardNickNameError = false;
        }
        break;
      case "cardLastName":
        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        } else if (
          data.cardLastName.length < 2 ||
          data.cardLastName.length > 20
        ) {
          errors.cardLastName =
            "Last name should consist of min 2 and max 20 characters";
          errors.cardLastNameError = true;
        } else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }
        break;
      case "cardAddress":
        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (
          data.cardAddress.length < 2 ||
          data.cardAddress.length > 50
        ) {
          errors.cardAddress =
            "Street address should consist of min 2 and max 50 characters ";
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }
        break;
      case "cardCity":
        if (Validator.isEmpty(data.cardCity)) {
          errors.cardCity = "City is required";
          errors.cardCityError = true;
        } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
          errors.cardCity =
            "City should consist of min 2 and max 30 characters";
          errors.cardCityError = true;
        } else {
          errors.cardCity = "";
          errors.cardCityError = false;
        }

        break;

      case "stateCard":
        if (Validator.isEmpty(data.stateCard)) {
          errors.stateCard = "State is required";
          errors.stateCardError = true;
        } else {
          errors.stateCard = "";
          errors.stateCardError = false;
        }
        break;

      case "cardZipCode":
        if (Validator.isEmpty(data.cardZipCode)) {
          errors.cardZipCode = "Zip code is required";
          errors.cardZipCodeError = true;
        } else if (
          data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 2
        ) {
          errors.cardZipCode =
            "Zip code should consist of min 2 and max 5 characters";
          errors.cardZipCodeError = true;
        } else {
          errors.cardZipCode = "";
          errors.cardZipCodeError = false;
        }

        break;
      case "cardCvv":
        if (Validator.isEmpty(data.cardCvv)) {
          errors.cardCvv = "CVV is required";
          errors.cardCvvError = true;
        } else if (
          data.cardCvv.replace(/_/g, "").length < 3 ||
          data.cardCvv.replace(/_/g, "").length > 4
        ) {
          errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
          errors.cardCvvError = true;
        } else {
          errors.cardCvv = "";
          errors.cardCvvError = false;
        }
        break;
      case "cardYear":
        if (Validator.isEmpty(data.cardYear)) {
          errors.cardYear = "Expiry Year is required";
          errors.cardYearError = true;
        } else if (data.cardYear.replace(/_/g, "").length !== 2) {
          errors.cardYear = "Expiration Year should be equal to two numbers";
          errors.cardYearError = true;
          // scrollViews.push(this.expirationYearRef);
        } else if (
          data.cardYear.replace(/_/g, "") <
          d
            .getFullYear()
            .toString()
            .substr(-2) *
            1
        ) {
          errors.cardYear = "Expiration Date must be not be in the past";
          errors.cardYearError = true;
        } else {
          if (
            data.cardYear.replace(/_/g, "").toString() ===
            (
              d
                .getFullYear()
                .toString()
                .substr(-2) * 1
            ).toString()
          ) {
            if (
              parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()
            ) {
              errors.cardMonth =
                "Expiration Month should be equal to or greater than the current month";
              errors.cardMonthError = true;
            }
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
          errors.cardYear = "";
          errors.cardYearError = false;
        }
        if (
          data.cardYear.replace(/_/g, "").toString() ===
          (
            d
              .getFullYear()
              .toString()
              .substr(-2) * 1
          ).toString()
        ) {
          if (parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        }
        break;
      case "cardMonth":
        if (data.cardMonth.replace(/_/g, "").length === 0) {
          errors.cardMonth = "Month is required";
          errors.cardMonthError = true;
        } else if (
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) <= 0 ||
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12
        ) {
          errors.cardMonth = "Month should be between 1 to 12";
          errors.cardMonthError = true;
        } else if (
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) ===
          Number.parseInt(
            (
              d
                .getFullYear()
                .toString()
                .substr(-2) * 1
            ).toString(),
            10
          )
        ) {
          if (parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        } else {
          errors.cardMonth = "";
          errors.cardMonthError = false;
        }
        break;
      case "":
        break;
      case "cardAddress2":
        break;
      case "recaptchaToken":
        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }
        break;
      default:
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber =
            "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }

        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        } else if (
          data.cardFirstName.length < 2 ||
          data.cardFirstName.length > 20
        ) {
          errors.cardFirstName =
            "First name should consist of min 2 and max 20 characters";
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }

        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        } else if (
          data.cardLastName.length < 2 ||
          data.cardLastName.length > 20
        ) {
          errors.cardLastName =
            "Last name should consist of min 2 and max 20 characters";
          errors.cardLastNameError = true;
        } else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }

        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (
          data.cardAddress.length < 2 ||
          data.cardAddress.length > 50
        ) {
          errors.cardAddress =
            "Street address should consist of min 2 and max 50 characters";
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }

        if (Validator.isEmpty(data.cardCity)) {
          errors.cardCity = "City is required";
          errors.cardCityError = true;
        } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
          errors.cardCity =
            "City should consist of min 2 and max 30 characters";
          errors.cardCityError = true;
        } else {
          errors.cardCity = "";
          errors.cardCityError = false;
        }

        if (Validator.isEmpty(data.stateCard)) {
          errors.stateCard = "State is required";
          errors.stateCardError = true;
        } else {
          errors.stateCard = "";
          errors.stateCardError = false;
        }

        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }

        if (Validator.isEmpty(data.cardZipCode)) {
          errors.cardZipCode = "Zip code is required";
          errors.cardZipCodeError = true;
        } else if (
          data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 2
        ) {
          errors.cardZipCode =
            "Zip code should consist of min 2 and max 5 characters";
          errors.cardZipCodeError = true;
        } else {
          errors.cardZipCode = "";
          errors.cardZipCodeError = false;
        }

        if (data.cardMonth.replace(/_/g, "").length === 0) {
          errors.cardMonth = "Month is required";
          errors.cardMonthError = true;
        } else if (
          parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12 ||
          parseInt(data.cardMonth.replace(/_/g, ""), 10) === 0
        ) {
          errors.cardMonth = "Expiry Month should be equal to two numbers";
          errors.cardMonthError = true;
        }

        if (Validator.isEmpty(data.cardCvv)) {
          errors.cardCvv = "CVV is required";
          errors.cardCvvError = true;
        } else if (
          data.cardCvv.replace(/_/g, "").length < 3 ||
          data.cardCvv.replace(/_/g, "").length > 4
        ) {
          errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
          errors.cardCvvError = true;
        } else {
          errors.cardCvv = "";
          errors.cardCvvError = false;
        }

        if (Validator.isEmpty(data.cardYear)) {
          errors.cardYear = "Expiry Year is required";
          errors.cardYearError = true;
        } else if (data.cardYear.replace(/_/g, "").length !== 2) {
          errors.cardYear = "Expiration Year should be equal to two numbers";
          errors.cardYearError = true;
          // scrollViews.push(this.expirationYearRef);
        } else if (
          data.cardYear.replace(/_/g, "") <
          d
            .getFullYear()
            .toString()
            .substr(-2) *
            1
        ) {
          errors.cardYear = "Expiration Date must be not be in the past";
          errors.cardYearError = true;
        } else {
          errors.cardYear = "";
          errors.cardYearError = false;
        }

        if (
          data.cardYear.replace(/_/g, "").toString() ===
          (
            d
              .getFullYear()
              .toString()
              .substr(-2) * 1
          ).toString()
        ) {
          if (
            parseInt(data.cardMonth.replace(/_/g, ""), 10) <
            parseInt(d.getMonth().toString(), 10)
          ) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        }
        break;
    }

    // console.log('ssssssss',errors)

    return {
      errorsState: errors,
      errors:
        errors.cardNumberError === false &&
        errors.cardFirstNameError === false &&
        errors.cardLastNameError === false &&
        errors.cardMonthError === false &&
        errors.cardYearError === false &&
        errors.cardCvvError === false &&
        errors.cardAddressError === false &&
        errors.cardCityError === false &&
        errors.stateCardError === false &&
        errors.cardZipCodeError === false &&
        errors.recaptchaTokenError === false
          ? {}
          : errors,
      isValid: !(
        errors.cardNumberError === false &&
        errors.cardFirstNameError === false &&
        errors.cardLastNameError === false &&
        errors.cardMonthError === false &&
        errors.cardYearError === false &&
        errors.cardCvvError === false &&
        errors.cardAddressError === false &&
        errors.cardCityError === false &&
        errors.stateCardError === false &&
        errors.cardZipCodeError === false &&
        errors.recaptchaTokenError === false
      ),
    };
  }

  componentDidUpdate(prevProps) {
    const {
      ViewChidCompanyData,
      BusinessUpdateUserProfileData,
      UpdateChidCompanyData,
      BusinessUserProfileData,
      SaveChidCompanyData,
      ChidCompanyData,
      DeleteChidCompanyData,
      uploadedChild,
    } = this.props.data;
    const {
      UpdateChidCompanyData1,
      SaveChidCompanyData1,
      ChidCompanyData1,
      stateSuccess,
      BusinessUpdateUserProfileData1,
      deleteChildStatus,
    } = this.state;

    if (this.state.successUpdateProfileState === true) {
      if (BusinessUpdateUserProfileData1 !== BusinessUpdateUserProfileData) {
        this.setState({
          BusinessUpdateUserProfileData1: BusinessUpdateUserProfileData,
          successUpdateProfileState: false,
          // isLoader: false,
        });
        setTimeout(() => {
          this.props.getBusinessUser(localStorage.getItem("userId"));
        }, 10000);
        // toast.info('User profile updated successfully!', {
        //   position: toast.POSITION.TOP_CENTER,
        // });
      }
    }

    if (stateSuccess !== BusinessUserProfileData) {
      this.setState({
        mobilePhone: BusinessUserProfileData.mobilePhone,
        firstName: BusinessUserProfileData.firstName,
        lastName: BusinessUserProfileData.lastName,
        state: BusinessUserProfileData.stateId,
        stateName: BusinessUserProfileData.stateName,
        email: BusinessUserProfileData.email,
        oldEmail: BusinessUserProfileData.email,
        startingYear: BusinessUserProfileData.startingYear,
        companyTitle: BusinessUserProfileData.companyTitle,
        workPhoneNumber: BusinessUserProfileData.workPhoneNumber,
        streeAddress: BusinessUserProfileData.streeAddress,
        streeAddress2: BusinessUserProfileData.streetAddress2,
        city: BusinessUserProfileData.city,
        zipCode: BusinessUserProfileData.zipCode,
        taxId: BusinessUserProfileData.taxId,
        industryTypeId: BusinessUserProfileData.industryTypeId,
        webSite: BusinessUserProfileData.webSite,
        separateTaxId: BusinessUserProfileData.separateTaxId,
        enterpriseType: BusinessUserProfileData.enterpriseType,
        companyName: BusinessUserProfileData.companyName,
        totalTaxId: BusinessUserProfileData.totalTaxId,
        bankruptcyStatus: BusinessUserProfileData.bankruptcyStatus,
        dissolvedStatus: BusinessUserProfileData.dissolvedStatus,
        acceptCC: BusinessUserProfileData.acceptCC,
        file: BusinessUserProfileData.signatureImageFilePath,
        cognitoClientId: BusinessUserProfileData.cognitoClientId,
        userId: BusinessUserProfileData.userId,
        countryCode: BusinessUserProfileData.countryCode,
        workCountryCode: BusinessUserProfileData.workCountryCode,
        companyProfileId: BusinessUserProfileData.companyProfileId,
        readDisclaimer: BusinessUserProfileData.readDisclaimer,
        readPrivacyPolicy: BusinessUserProfileData.readPrivacyPolicy,
        readLetterOfAgency: BusinessUserProfileData.readLetterOfAgency,
        readUserAgreement: BusinessUserProfileData.readUserAgreement,
        planPriceId: BusinessUserProfileData.planPriceId,
        privacyPolicyPath: BusinessUserProfileData.privacyPolicyPath,
        agreementLetterPath: BusinessUserProfileData.agreementLetterPath,
        letterOfAgencyPath: BusinessUserProfileData.letterOfAgencyPath,
        stateSuccess: BusinessUserProfileData,
        otherIndustryType: BusinessUserProfileData.otherIndustryType,
        walletBalance: BusinessUserProfileData.walletBalance
          ? BusinessUserProfileData.walletBalance
          : 0,

        signatureDefaultValue: `${BusinessUserProfileData.firstName} ${BusinessUserProfileData.lastName}`,
        isLoader: false,
      });
      if (BusinessUserProfileData.stateId !== "") {
        this.callgetAllChildCompanyProfile(
          BusinessUserProfileData.companyProfileId
        );
      }
    }

    if (this.state.data !== ViewChidCompanyData) {
      this.setState({
        childCompanyProfileId: ViewChidCompanyData.childCompanyProfileId,
        cCompanyName: ViewChidCompanyData.companyName,
        cStreeAddress: ViewChidCompanyData.streeAddress,
        cCity: ViewChidCompanyData.city,
        cState: ViewChidCompanyData.stateId,
        cZipCode: ViewChidCompanyData.zipCode,
        cSeparateTaxId: ViewChidCompanyData.separateTaxId,
        cStartingYear: ViewChidCompanyData.startingYear,
        cOtherIndustryType: ViewChidCompanyData.otherIndustryType,
        cContactName: ViewChidCompanyData.contactName,
        cContactEmail: ViewChidCompanyData.contactEmail,
        cContactNumber: ViewChidCompanyData.contactNumber,
        cEin: ViewChidCompanyData.ein,
        cEntityName: ViewChidCompanyData.entityName,
        cWebSite: ViewChidCompanyData.webSite,
        cTaxId: ViewChidCompanyData.taxId,
        cDissolvedStatus: ViewChidCompanyData.dissolvedStatus,
        cBankruptcyStatus: ViewChidCompanyData.bankruptcyStatus,
        cAcceptCC: ViewChidCompanyData.acceptCC,
        cIndustryTypeId: ViewChidCompanyData.industryTypeId,
        data: ViewChidCompanyData,
      });
    }

    if (ChidCompanyData.records !== undefined) {
      if (ChidCompanyData1 !== ChidCompanyData.records) {
        this.setState({
          recordsCompany: ChidCompanyData.records,
          ChidCompanyData1: ChidCompanyData.records,
          isLoader: false,
        });
      }
    } else if (ChidCompanyData1 !== ChidCompanyData) {
      this.setState({
        recordsCompany: ChidCompanyData,
        ChidCompanyData1: ChidCompanyData,
        isLoader: false,
      });
    }

    if (deleteChildStatus === true) {
      if (DeleteChidCompanyData === 200) {
        // toast.info('Company profile deleted successfully!', {
        //   position: toast.POSITION.TOP_CENTER,
        // });
        setTimeout(() => {
          this.callgetAllChildCompanyProfile(this.state.companyProfileId);
        }, 2000);
        this.setState({ deleteChildStatus: false });
      }
    }

    if (this.state.saveChidCompanyDataState === true) {
      if (SaveChidCompanyData !== undefined) {
        if (SaveChidCompanyData1 !== SaveChidCompanyData) {
          this.setState({
            SaveChidCompanyData1: SaveChidCompanyData,
            saveChidCompanyDataState: false,
            CompanyForm: false,
          });
          // toast.info('Company profile saved successfully!', {
          //   position: toast.POSITION.TOP_CENTER,
          // });
          setTimeout(() => {
            this.callgetAllChildCompanyProfile(this.state.companyProfileId);
          }, 2000);
        }
      }
    }

    if (this.state.UpdateChidCompanyDataState === true) {
      if (UpdateChidCompanyData !== undefined) {
        if (UpdateChidCompanyData1 !== UpdateChidCompanyData) {
          this.setState({
            UpdateChidCompanyData1: UpdateChidCompanyData,
            UpdateChidCompanyDataState: false,
            CompanyForm: false,
          });

          // toast.info('Company profile update successfull!', {
          //   position: toast.POSITION.TOP_CENTER,
          // });
          setTimeout(() => {
            this.callgetAllChildCompanyProfile(this.state.companyProfileId);
          }, 2000);
        }
      }
    }

    if (uploadedChild !== prevProps.data.uploadedChild) {
      this.setState({
        isLoader: false,
        uploadCsvFile: {},
      });
      if (uploadedChild.status === "OK") {
        // toast.info('CSV Uploaded Successfully', {
        //   position: toast.POSITION.TOP_CENTER,
        // });
      } else {
        if (uploadedChild.list !== undefined) {
          ToastsStore.info(uploadedChild.list[0], 5000, "toast-error-msg");
        } else {
          if (uploadedChild.code === 400) {
            ToastsStore.info(
              uploadedChild.collectMessage.messageShort,
              5000,
              "toast-error-msg"
            );
          }
        }
        // toast.info('Invalid CSV', {
        //   position: toast.POSITION.TOP_CENTER,
        // });
      }
      this.props.getBusinessUser(localStorage.getItem("userId"));
    }
  }

  callgetAllChildCompanyProfile = (companyProfileId) => {
    const params = {
      companyProfileId,
      pageNumber: this.state.pageNumber,
      pageSize: this.state.pageSize,
      searchKeyword: "",
    };
    this.props.getAllChildCompanyProfile(params);
  };

  paginateAllChildCompanyProfile = (data) => {
    const params = {
      companyProfileId: this.state.companyProfileId,
      pageNumber: data.page,
      pageSize: data.pageSize,
      searchKeyword: "",
    };
    this.props.getAllChildCompanyProfile(params);
  };

  handleAddCompany = () => {
    const { companyInformation } = this.state;
    this.setState({
      companyInformation: companyInformation.concat([
        { name: "", company: "" },
      ]),
    });
  };

  handleTextChangeName = (idx) => (evt) => {
    const { companyInformation } = this.state;
    const newQuestionText = companyInformation.map((document, sidx) => {
      if (idx !== sidx) return document;
      return { name: evt.target.value };
    });
    this.setState({ companyInformation: newQuestionText });
  };

  handleTextChangeCompany = (idx) => (evt) => {
    const { companyInformation } = this.state;
    const newQuestionText = companyInformation.map((document, sidx) => {
      if (idx !== sidx) return document;
      return { company: evt.target.value };
    });
    this.setState({ companyInformation: newQuestionText });
  };

  isValidBusiness() {
    const { errors, isValidBusiness } = this.validateInputBusiness(this.state);
    if (!isValidBusiness) {
      this.setState({ errors });
    }
    return isValidBusiness;
  }

  disburseAmountPopup = () => {
    if (this.state.walletBalance) {
      const walletBalance = this.state.walletBalance;

      const data = {
        walletBalance: walletBalance,
        transferMode: this.state.transcardAccountState
          ? "ACH"
          : "Instant Transfer",
      };

      this.props.showNetAmountToUser({ data });
    }
    if (this.state.transcardAccountState || this.state.transcardCardState) {
      this.setState({
        disburseAmountPopupState: true,
      });
    } else {
      this.setState({
        disburseAmountPopupState: true,
      });
    }
    // this.setState({
    //   disburseAmountPopupState: true,
    // });
  };

  /**
   * Check if valid company
   */
  isValidBusinessCompany() {
    const {
      errors,
      isValidBusinessCompnay,
    } = this.validateInputBusinessCompany(this.state);
    if (!isValidBusinessCompnay) {
      this.setState({ errors });
    }
    return isValidBusinessCompnay;
  }

  openDisbursePopup = () => {
    this.setState({
      disburseAmountPopupState: true,
    });
  };

  closeDisbursePopup = () => {
    this.setState({
      disburseAmountPopupState: false,
    });
  };

  openCardDisbursePopup = () => {
    this.setState({
      disburseCardPopupState: true,
    });
  };

  closeCardDisbursePopup = () => {
    this.setState({
      disburseCardPopupState: false,
    });
  };

  disburseAmount = () => {
    const walletBalance = this.state.walletBalance;
    this.setState({
      disburseAmountPopupState: false,
      isLoader: true,
    });

    const data = {
      debitedAmount: walletBalance,
      userId: localStorage.getItem("userId"),
      transferMode: this.state.transcardAccountState
      ? "ACH"
      : "Instant Transfer",
    };

    this.props.disbursePayment({ data });
  };

  validateInputBusinessCompany(data) {
    const errors = {};

    if (Validator.isEmpty(data.cCompanyName)) {
      errors.cCompanyName = "Company Name is Required";
      errors.cCompanyNameError = true;
    } else if (data.cCompanyName.length < 2 || data.cCompanyName.length > 50) {
      errors.cCompanyName =
        "Company Name and DBA should be between 2 to 50 characters";
      errors.cCompanyNameError = true;
    }

    if (Validator.isEmpty(data.cContactName)) {
      errors.cContactName = "Contact Name is Required";
      errors.cContactNameError = true;
    } else if (data.cContactName.length < 2 || data.cContactName.length > 50) {
      errors.cContactName = "Contact Name should be between 2 to 50 characters";
      errors.cContactNameError = true;
    }

    if (Validator.isEmpty(data.cEntityName)) {
      errors.cEntityName = "Entity Name is Required";
      errors.cEntityNameError = true;
    } else if (data.cEntityName.length < 2 || data.cEntityName.length > 50) {
      errors.cEntityName =
        "Entity Name and DBA should be between 2 to 50 characters";
      errors.cEntityNameError = true;
    }

    // if (Validator.isEmpty(data.cEin)) {
    //   errors.cEin = 'Ein Name is Required';
    //   errors.cEinError = true;
    // } else if (data.cEin.length !== 9) {
    //   errors.cEin = 'Ein should be between 9';
    //   errors.cEinError = true;
    // }

    if (!data.cContactNumber) {
      errors.cContactNumber = "Contact Number is Required";
      errors.cContactNumberError = true;
    } else if (
      data.cContactNumber.replace(/\s/g, "").replace(/[_-]/g, "").length !== 10
    ) {
      errors.cContactNumber = "Please enter at least 10 digit";
      errors.cContactNumberError = true;
    }

    if (!Validator.isEmail(data.cContactEmail)) {
      errors.cContactEmail = "Email is Not Valid";
      errors.cContactEmailError = true;
    }

    if (Validator.isEmpty(data.cStreeAddress)) {
      errors.cStreeAddress = "Street Address is Required";
      errors.cStreeAddressError = true;
    } else if (
      data.cStreeAddress.length < 2 ||
      data.cStreeAddress.length > 50
    ) {
      errors.cStreeAddress =
        "Street address should be between 2 to 50 characters";
      errors.cStreeAddressError = true;
    }

    if (!data.cCity) {
      errors.cCity = "City is Required";
      errors.cCityError = true;
    } else if (data.cCity.length < 2 || data.cCity.length > 30) {
      errors.cCity = "City should be between 2 to 30 characters";
      errors.cCityError = true;
    }

    if (!data.cState) {
      errors.cState = "State is Required";
      errors.cStateError = true;
    }

    if (!data.cZipCode) {
      errors.cZipCode = "Zip Code is Required";
      errors.cZipCodeError = true;
    } else if (data.cZipCode.length < 2 || data.cZipCode.length > 5) {
      errors.cZipCode = "Zip code should be between 2 to 5 characters";
      errors.cZipCodeError = true;
    }

    if (!data.cTaxId) {
      errors.cTaxId = "Tax Id is Required";
      errors.cTaxIdError = true;
    } else if (
      data.cTaxId.replace(/\s/g, "").replace(/[_-]/g, "").length !== 9
    ) {
      errors.cTaxId = "Ein should be 9 digit";
      errors.cTaxIdError = true;
    }

    if (data.cWebSite !== "") {
      const webSiteRe = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
      if (!webSiteRe.test(data.cWebSite)) {
        errors.cWebSite = "Invalid url";
        errors.cWebSiteError = true;
      }
    }

    // if (!data.cIndustryTypeId) {
    //   errors.cIndustryTypeId = "Industry is Required";
    //   errors.cIndustryTypeIdError = true;
    // }
    // if (!data.cAcceptCC) {
    //   errors.cAcceptCC = "Aceppt CC is Required";
    //   errors.cAcceptCCError = true;
    // }
    // if (!data.cBankruptcyStatus) {
    //   errors.cBankruptcyStatus = "Bankruptcy is Required";
    //   errors.cBankruptcyStatusError = true;
    // }
    // if (!data.cDissolvedStatus) {
    //   errors.cDissolvedStatus = "Dissolve is Required";
    //   errors.cDissolvedStatusError = true;
    // }

    // if (!data.cStartingYear) {
    //   errors.cStartingYear = "Starting Year is Required";
    //   errors.cStartingYearError = true;
    // }

    if (data.cIndustryTypeId === 119) {
      if (!data.cOtherIndustryType) {
        errors.cOtherIndustryType = "Other industry type is Required";
        errors.cOtherIndustryTypeError = true;
        // otherIndustryType
      }
    }

    return {
      errors,
      isValidBusinessCompnay: isEmpty(errors),
    };
  }

  /**
   * Business Form Validation
   */
  validateInputBusiness(data) {
    const errors = {};
    if (!data.firstName) {
      errors.firstName = "First name is Required";
      errors.firstNameError = true;
    } else if (data.firstName.length < 2 || data.firstName.length > 20) {
      errors.firstName = "First name should be between 2 to 20 characters";
      errors.firstNameError = true;
    }
    if (data.email !== "") {
      const isemailVerified = this.props.data.emailVerifyData;
      if (this.state.email !== this.state.oldEmail) {
        if (Object.keys(isemailVerified).length > 0) {
          if (isemailVerified.collectMessage !== undefined) {
            if (
              isemailVerified.collectMessage.messageShort ===
              "User email already exist"
            ) {
              errors.email =
                "This user's email address has already been added to Collectively";
            }
          }
        }
      }
    }
    if (!Validator.isEmail(data.email)) {
      errors.email = "Email is Not Valid";
      errors.emailError = true;
    }

    if (!data.lastName) {
      errors.lastName = "Last name is Required";
      errors.lastNameError = true;
    } else if (data.lastName.length < 2 || data.lastName.length > 30) {
      errors.lastName = "Last name should be between 2 to 30 characters";
      errors.lastNameError = true;
    }

    if (!data.companyTitle) {
      errors.companyTitle = "Title/Position is Required";
      errors.companyTitleError = true;
    } else if (data.companyTitle.length < 2) {
      errors.companyTitle = "Please enter at least 2 characters";
      errors.companyTitleError = true;
    }

    if (!data.mobilePhone) {
      errors.mobilePhone = "Mobile number is Required";
      errors.mobilePhoneError = true;
    } else if (
      data.mobilePhone.replace(/\s/g, "").replace(/[_-]/g, "").length !== 10
    ) {
      errors.mobilePhone = "Please enter at least 10 digit";
      errors.mobilePhoneError = true;
    }

    if (!data.workPhoneNumber) {
      errors.workPhoneNumber = "Work phone Number is Required";
      errors.workPhoneNumberError = true;
    } else if (
      data.workPhoneNumber.replace(/\s/g, "").replace(/[_-]/g, "").length !== 10
    ) {
      errors.workPhoneNumber = "Please enter at least 10 digit";
      errors.workPhoneNumberError = true;
    }

    if (Validator.isEmpty(data.companyName)) {
      errors.companyName = "Company Name is Required";
      errors.companyNameError = true;
    } else if (data.companyName.length < 2 || data.companyName.length > 50) {
      errors.companyName =
        "Company Name and DBA should be between 2 to 50 characters";
      errors.companyNameError = true;
    }
    if (Validator.isEmpty(data.streeAddress)) {
      errors.streeAddress = "Street Address is Required";
      errors.streeAddressError = true;
    } else if (data.streeAddress.length < 2 || data.streeAddress.length > 50) {
      errors.streeAddress =
        "Street address should be between 2 to 50 characters";
      errors.streeAddressError = true;
    }

    if (!data.city) {
      errors.city = "City is Required";
      errors.cityError = true;
    } else if (data.city.length < 2 || data.city.length > 30) {
      errors.city = "City should be between 2 to 30 characters";
      errors.cityError = true;
    }

    if (!data.state) {
      errors.state = "State is Required";
      errors.stateError = true;
    }

    if (!data.zipCode) {
      errors.zipCode = "Zip Code is Required";
      errors.zipCodeError = true;
    } else if (data.zipCode.length < 2 || data.zipCode.length > 5) {
      errors.zipCode = "Zip code should be between 2 to 5 characters";
      errors.zipCodeError = true;
    }
    if (!data.separateTaxId) {
      errors.separateTaxId = "Separate EINs is Required";
      errors.separateTaxIdError = true;
      // scrollViews.push(this.bottomDownRef);
    }
    if (data.taxId.replace(/\s/g, "").replace(/[_-]/g, "").length !== 9) {
      errors.taxId = "Please enter at least 9 digit";
      errors.taxIdError = true;
    }
    if (!data.acceptCC) {
      errors.acceptCC = "Company Credit Cards is Required";
      errors.acceptCCError = true;
      // scrollViews.push(this.bottomDownRef);
    }
    // separateTaxId
    if (data.separateTaxId === "yes") {
      if (!data.totalTaxId) {
        errors.totalTaxId = "Tax id is Required";
        errors.totalTaxIdError = true;
      }
      const re = /[0-9A-F:]+/g;
      if (!re.test(data.totalTaxId)) {
        errors.totalTaxId = "Please add additional ein’s here";
        errors.totalTaxIdError = true;
      }
      // if (data.totalTaxId.length > 3) {
      //   errors.totalTaxId = 'Enter max 3 number ';
      //   errors.totalTaxIdError = true;
      // }
    }

    if (!data.taxId) {
      errors.taxId = "Tax Id is Required";
      errors.taxIdError = true;
    }

    if (data.webSite !== "") {
      const webSiteRe = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
      if (!webSiteRe.test(data.webSite)) {
        errors.webSite = "Invalid url";
        errors.webSiteError = true;
      }
    }

    if (!data.industryTypeId) {
      errors.industryTypeId = "Industry is Required";
      errors.industryTypeIdError = true;
    }

    if (data.industryTypeId === 119) {
      if (!data.otherIndustryType) {
        errors.otherIndustryType = "Other industry type is Required";
        errors.otherIndustryTypeError = true;
      }
    }

    if (!data.startingYear) {
      errors.startingYear = "Starting Year is Required";
      errors.startingYearError = true;
    }

    return {
      errors,
      isValidBusiness: isEmpty(errors),
    };
  }

  linkAccountPopup = (e) => {
    // if (e == "addNewAccount") {
    //   this.setState({
    //     nextButtonStepActive: true,
    //     linkAccountStep1: true,
    //     addMultipleAccountState: true,
    //     addNewAccWithoutAdd: "addNewAccount",
    //     value: "1",
    //     address1PopupError: "",
    //     cityPopupError: "",
    //     statePopupError: "",
    //     zipPopupError: "",
    //   });
    // } else {
    //   this.setState({
    //     linkAccountStep1: true,
    //     addMultipleAccountState: e.target.name == "addAccount" ? true : false,
    //   });
    // }
    // if (e.target && e.target.value == "addNewLinkAccount") {
    //   this.setState({
    //     linkAccountStep1: true,
    //   });
    // }

    if (e == "addNewAccount") {
      this.setState({
        nextButtonStepActive: true,
        linkAccountStep1: true,
        addNewAccWithoutAdd: "addNewAccount",
        value: "1",
        address1PopupError: "",
        cityPopupError: "",
        statePopupError: "",
        zipPopupError: "",
        addMultipleAccountState: true,
      });
    } else {
      this.setState({
        linkAccountStep1: true,
        // linkCardAccountStep1: true,
        addNewAccWithoutAdd: "",
        addMultipleAccountState: e == "addNewLinkAccount" ? false : true,
      });
    }
  };

  addedBankReviewPopup = (e) => {
    this.setState({
      bankAccountConfirmationPopup: true,
    });
  };

  linkCardPopup = (e) => {
    if (e == "addNewAccount") {
      this.setState({
        nextButtonStepActive: true,
        addNewCardWithoutAdd: "addNewCard",
        value: "3",
        linkCardAccountStep1: true,
        addMultipleCardState: true,
      });
    } else {
      this.setState({
        // linkAccountStep1: true,
        linkCardAccountStep1: true,
        addNewCardWithoutAdd: "",
        addMultipleCardState: e == "addNewLinkCard" ? false : true,
      });
    }
  };

  closeInstantPopup = () => {
    this.setState({
      instantTransferPopupState: false,
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      cardFirstName: "",
      cardNickName: "",
      cardLastName: "",
      cardLastNameError: "",
      cardFirstNameError: "",
      achState: false,
      instantTransferState: false,
      cardErrors: {
        cardMonthError: true,
        cardNumberError: true,
      },

      cardErrorsState: {
        cardMonthError: true,
        cardNumberError: true,
      },
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
    });
  };

  /**
   * Submit Form Business
   */
  handleSubmitBusiness(e) {
    e.preventDefault();
    if (this.isValidBusiness()) {
      this.setState({
        errors: {},
        BusinessUpdateUserProfileData1: [],
        isLoader: true,
        successUpdateProfileState: true,
        isLoader: true,
      });
      this.props.updateBusinessUser(this.state);
    }
  }

  AckOnchange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSeletcedYearChangeConsumer(date) {
    this.setState({ since: date });
  }

  editAccount = () => {
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
    this.setState({
      openEditModel: true,
    });
  };

  editCard = () => {
    this.props.getAddedCardsForUser(localStorage.getItem("userId"));
    this.setState({
      openEditCardModel: true,
    });
  };

  handleSubmitNext = () => {
    this.setState({
      value: "2",
    });
  };

  handleCancel = () => {
    this.setState({
      linkAccountStep1: false,
      linkCardAccountStep1: false,
      addAccountStep1: false,
      addCardAccountStep1: false,
      bankAccountConfirmationPopup: false,
      addMultipleAccountState: false,
      checkboxState: false,
      viewAccountState: false,
      errorCheckbox: true,
      accountHolderName: "",
      accountNumber: "",
      routingNumber: "",
      accountType: "",
      displayName: "",
      value: "1",
      routingNumberError: "",
      accountNumberError: "",
      address1Popup: "",
      address2Popup: "",
      cityPopup: "",
      statePopup: "",
      statePopupError: "",
      stateCardPopupError: "",
      stateCardPopup: "",
      zipPopup: "",
      address1PopupError: "",
      address2PopupError: "",
      cityPopupError: "",
      zipPopupError: "",
      zipCodeError: "",
      stateError: "",
      statePopupName: "",
      stateCardPopupName: "",
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
      achState: false,
      instantTransferState: false,
      addressNextButton: false,
      addressCardNextButton: false,
      nextButtonStepActive: false,
      nextCardButtonStepActive: false,
      cardFirstName: "",
      cardFirstNameError: false,
      cardLastName: "",
      cardLastNameError: false,
      cardNickName: "",
      cardNickNameError: false,
      cardNumber: "",
      cardNumberError: false,
      cardMonth: "",
      cardMonthError: false,
      cardYear: "",
      cardYearError: false,
      cardCvv: "",
      cardCvvError: false,
    });
  };

  addAccountPopup = (e) => {
    this.setState({
      addAccountStep1: true,
      addMultipleAccountState: e.target.name == "addAccount" ? true : false,
    });
  };

  viewAccountsPopup = () => {
    this.setState({
      viewAccountState: true,
      disburseAmountPopupState: false,
    });
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
  };

  handleSubmitBack = () => {
    this.setState({
      value: "1",
    });
  };

  createAccount = () => {
    const data = {
      userId: localStorage.getItem("userId"),
      accountHolderName: this.state.accountHolderName,
      accountNumber: this.state.accountNumber,
      routingNumber: this.state.routingNumber,
      accountType: this.state.accountType,
      displayName: this.state.displayName,
    };
    this.setState({
      isLoader: true,
    });
    this.props.createTranscardAccount(localStorage.getItem("userId"));
  };

  handleAddNewAccount = (e) => {
    e.preventDefault();
    this.setState({
      bankAccountConfirmationPopup: false,
    });
    this.linkAccountPopup(e.target.value);
  };

  handleAddNewCard = (e) => {
    e.preventDefault();
    this.setState({
      bankCardConfirmationPopup: false,
      cardNickName: "",
    });
    this.linkCardPopup(e.target.value);
  };

  addedCardReviewPopup = (e) => {
    this.setState({
      // bankAccountConfirmationPopup: true,
      bankCardConfirmationPopup: true,
    });
  };

  AddMultipleAccount = async () => {
    this.setState({
      isLoader: true,
    });
    const data = {
      userId: localStorage.getItem("userId"),
      accountHolderName: this.state.accountHolderName,
      accountNumber: this.state.accountNumber,
      routingNumber: this.state.routingNumber,
      accountType: this.state.accountType,
      displayName: this.state.displayName,
    };
    await this.props.addUserBankAccount({ data });
  };

  makeDefaultAccount = (e) => {
    if (e.target.name == "Make Default") {
      const data = {
        bankAccountId: e.target.value,
        userId: localStorage.getItem("userId"),
      };
      this.props.setDefaultBankAccount({ data });
    }
  };

  removeBankAccount = async (e) => {
    const data = {
      bankAccountId: e.target.value,
      userId: localStorage.getItem("userId"),
    };
    await this.props.deleteUserBankAccount({ data });
    setTimeout(() => {
      this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
    }, 1000);
    this.setState({
      openEditModel: false,
      transcardAccountState: false,
      showDeleteConfirmation: false,
      addNewAccWithoutAdd: "",
    });
  };

  removeBankCard = async (e) => {
    const data = {
      bankAccountId: e.target.value,
      userId: localStorage.getItem("userId"),
    };
    await this.props.deleteUserCard({ data });
    setTimeout(() => {
      this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
    }, 1000);

    this.setState({
      openEditModel: false,
      openEditCardModel: false,
      transcardAccountState: false,
      transcardCardState: false,
      showDeleteConfirmation: false,
    });
  };

  componentWillUnmount() {
    this.props.clearDataEmail();
  }

  handleShowDeleteConfirmation = () => {
    this.setState({
      showDeleteConfirmation: !this.state.showDeleteConfirmation,
    });
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    let linkCardCode = newProps.receiveTranscardCardApi.code;
    let linkCode = newProps.recieveLinkAccountProfile.code;
    if (
      newProps.receiveGetAllBankAccountsForUser &&
      newProps.receiveGetAllBankAccountsForUser.data &&
      newProps.receiveGetAllBankAccountsForUser.data.code == "400"
    ) {
      this.setState({
        hasAnyActiveAccount: false,
        noAccountLinked: true,
        userHasNoAccounts: true,
      });
    }

    if (
      newProps.receiveGetAllAddedCardsForUser &&
      newProps.receiveGetAllAddedCardsForUser.data.code == "400"
    ) {
      this.setState({
        hasAnyActiveCard: false,
        noCardLinked: true,
      });
    }

    if (
      newProps.receiveGetAllAddedCardsForUser &&
      newProps.receiveGetAllAddedCardsForUser.data &&
      newProps.receiveGetAllAddedCardsForUser.data.code == 200
    ) {
      this.setState({
        userHasNoCards: false,
        AddNewCardState: true,
        cardAlreadyLinked: true,
        // hasAnyActiveAccount: false,
        noCardLinked: false,
      });
    }

    if (
      this.props.receiveGetAllBankAccountsForUser &&
      this.props.receiveGetAllBankAccountsForUser.data &&
      this.props.receiveGetAllBankAccountsForUser.data.code == "400" &&
      this.props.receiveGetAddedBankAccountsForUser &&
      this.props.receiveGetAddedBankAccountsForUser.code == "400"
    ) {
      this.setState({
        userHasNoAccounts: true,
      });
    }
    // else {
    //   this.setState({
    //     userHasNoAccounts: false,
    //   });
    // }

    if (
      this.props.receiveGetAllAddedCardsForUser &&
      this.props.receiveGetAllAddedCardsForUser.data &&
      this.props.receiveGetAllAddedCardsForUser.data.code == "400" &&
      this.props.receiveGetAddedCardsForUser &&
      this.props.receiveGetAddedCardsForUser.code == "400"
    ) {
      this.setState({
        userHasNoCards: true,
        transcardCardState: false,
      });
    } else {
      this.setState({
        userHasNoAccounts: false,
      });
    }

    if (
      newProps.receiveGetAllBankAccountsForUser &&
      newProps.receiveGetAllBankAccountsForUser.data &&
      newProps.receiveGetAllBankAccountsForUser.data.code == 200
    ) {
      this.setState({
        userHasNoAccounts: false,
        AddNewBankAccountState: true,
        cardAlreadyLinked: true,
        // hasAnyActiveAccount: false,
        noAccountLinked: false,
      });
    }

    if (
      newProps.receiveGetAddedBankAccountsForUser &&
      newProps.receiveGetAddedBankAccountsForUser.data &&
      newProps.receiveGetAddedBankAccountsForUser.data.code &&
      newProps.receiveGetAddedBankAccountsForUser.data.code == "200" &&
      newProps.receiveGetAddedBankAccountsForUser.data.result &&
      newProps.receiveGetAddedBankAccountsForUser.data.result.length > 0
    ) {
      this.setState({
        transcardAccountState: true,
        transcardCardState: false,
        hasAnyActiveAccount: true,
        noAccountLinked: false,
      });
    } else {
      this.setState({
        hasAnyActiveAccount: false,
      });
    }
    if (
      newProps.receiveGetAddedCardsForUser &&
      newProps.receiveGetAddedCardsForUser.code &&
      newProps.receiveGetAddedCardsForUser.code == "200" &&
      newProps.receiveGetAddedCardsForUser.result &&
      newProps.receiveGetAddedCardsForUser.result.length > 0
    ) {
      this.setState({
        transcardCardState: true,
        transcardAccountState: false,
        hasAnyActiveCard: true,
        noCardLinked: false,
      });
    }

    if (
      newProps.receiveUpdateBankAccountDetails.data &&
      newProps.receiveUpdateBankAccountDetails.data.code == "200" &&
      newProps.receiveAddUserBankAccountApi.code != "406" &&
      newProps.receiveAddUserBankAccountApi.code != "200" &&
      this.state.isLoader == true &&
      newProps.recieveDisburseAmount.code != "200"
    ) {
      this.setState({
        isLoader: false,
        openEditModel: false,
      });
      toast.success(
        newProps.receiveUpdateBankAccountDetails.data.collectMessage
          .messageShort,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
      this.props.clearReceiveUpdateBankAccountDetails();
    }
    if(newProps.receiveAddBusinessUserCard.data && newProps.receiveAddBusinessUserCard.data.code) {
      if (
        newProps.receiveUpdateCardDetails &&
        newProps.receiveUpdateCardDetails.data &&
        newProps.receiveUpdateCardDetails.data.code == "200" &&
        newProps.receiveAddBusinessUserCard.data.code != "406" &&
        newProps.receiveAddBusinessUserCard.data.code != "200" &&
        this.state.isLoader == true &&
        newProps.recieveDisburseAmount.code != "200"
      ) {
        this.setState({
          isLoader: false,
          openEditCardModel: false,
        });
        toast.success(
          newProps.receiveUpdateCardDetails.data.collectMessage.messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
        this.props.clearReceiveUpdateCardDetails();
      }
    }else if (
      newProps.receiveUpdateCardDetails &&
      newProps.receiveUpdateCardDetails.data &&
      newProps.receiveUpdateCardDetails.data.code == "200" &&
      this.state.isLoader == true &&
      newProps.recieveDisburseAmount.code != "200"
    ) {
      this.setState({
        isLoader: false,
        openEditCardModel: false,
      });
      toast.success(
        newProps.receiveUpdateCardDetails.data.collectMessage.messageShort,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      this.props.getAddedCardsForUser(localStorage.getItem("userId"));
    }

    if (
      this.props.receiveGetAddedBankAccountsForUser &&
      this.props.receiveGetAddedBankAccountsForUser.data &&
      this.props.receiveGetAddedBankAccountsForUser.data.code == "200"
    ) {
      this.setState({
        bankName: this.props.receiveGetAddedBankAccountsForUser.data.result[0]
          .accountDisplayName,
        bankId: this.props.receiveGetAddedBankAccountsForUser.data.result[0].id,
        AddNewBankAccountState: false,
        transcardAccountState: true,
        hasAnyActiveAccount: true,
      });
    }
    if (
      this.props.receiveGetAddedCardsForUser &&
      this.props.receiveGetAddedCardsForUser.code == "200" && 
      newProps.receiveAddBusinessUserCard.code != "406"
    ) {
      this.setState({
        cardNickName: this.props.receiveGetAddedCardsForUser.result[0]
          .cardNickName,
        cardId: this.props.receiveGetAddedCardsForUser.result[0].id,
        AddNewCardState: false,
        transcardCardState: true,
      });
    }

    if (
      newProps.receiveGetAddedCardsForUser &&
      newProps.receiveGetAddedCardsForUser.code == "400" &&
      newProps.receiveAddBusinessUserCard.code != "406"
    ) {
      this.setState({
        AddNewCardState: true,
        hasAnyActiveCard: false,
        // noCardLinked: false,
      });
    }
    if (
      newProps.receiveGetAddedBankAccountsForUser &&
      newProps.receiveGetAddedBankAccountsForUser.code == "400" &&
      newProps.receiveAddUserBankAccountApi.code != "406"
    ) {
      this.setState({
        AddNewBankAccountState: true,
        hasAnyActiveAccount: false,
        noAccountLinked: false,
      });
    }

    if (newProps.receiveSetDefaultBankAccount) {
      if (
        (this.props.receiveSetDefaultBankAccount &&
          !this.props.receiveSetDefaultBankAccount.config &&
          newProps.receiveSetDefaultBankAccount.config &&
          newProps.receiveSetDefaultBankAccount.config.data) ||
        (this.props.receiveSetDefaultBankAccount &&
          this.props.receiveSetDefaultBankAccount.setAt !=
            newProps.receiveSetDefaultBankAccount.setAt)
      ) {
        this.setState({
          achState: false,
          instantTransferState: false,
        });
        toast.success(
          newProps.receiveSetDefaultBankAccount.data &&
            newProps.receiveSetDefaultBankAccount.data.collectMessage
              .messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
        this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
      }
    }

    if (newProps.receiveSetDefaultCard) {
      if (
        (this.props.receiveSetDefaultCard &&
          !this.props.receiveSetDefaultCard.config &&
          newProps.receiveSetDefaultCard.config &&
          newProps.receiveSetDefaultCard.config.data) ||
        (this.props.receiveSetDefaultCard &&
          this.props.receiveSetDefaultCard.setAt !=
            newProps.receiveSetDefaultCard.setAt)
      ) {
        this.setState({
          transcardCardState: true,
          achState: false,
          instantTransferState: false,
          radioAddedCardChecked: false,
        });
        toast.success(
          newProps.receiveSetDefaultCard.data &&
            newProps.receiveSetDefaultCard.data.collectMessage.messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
      }
    }
    if (newProps.receiveDeleteUserCard) {
      if (
        (this.props.receiveDeleteUserCard &&
          !this.props.receiveDeleteUserCard.config &&
          newProps.receiveDeleteUserCard.config &&
          newProps.receiveDeleteUserCard.config.data) ||
        (this.props.receiveDeleteUserCard &&
          this.props.receiveDeleteUserCard.setAt !=
            newProps.receiveDeleteUserCard.setAt)
      ) {
        this.setState({
          radioAddedAccountChecked: false,
          radioCardValue: "",
          achState: false,
          instantTransferState: false,
        });
        toast.success(
          newProps.receiveDeleteUserCard.data &&
            newProps.receiveDeleteUserCard.data.collectMessage.messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
        this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
      }
    }

    if (newProps.receiveDeleteUserBankAccount) {
      if (
        (this.props.receiveDeleteUserBankAccount &&
          !this.props.receiveDeleteUserBankAccount.config &&
          newProps.receiveDeleteUserBankAccount.config &&
          newProps.receiveDeleteUserBankAccount.config.data) ||
        (this.props.receiveDeleteUserBankAccount &&
          this.props.receiveDeleteUserBankAccount.setAt !=
            newProps.receiveDeleteUserBankAccount.setAt)
      ) {
        this.setState({
          radioAddedAccountChecked: false,
          radioAccountValue: "",
          achState: false,
          instantTransferState: false,
        });
        toast.success(
          newProps.receiveDeleteUserBankAccount.data &&
            newProps.receiveDeleteUserBankAccount.data.collectMessage
              .messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
        this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
      }
    }

    // if (
    //   this.state.transcardAccountState != true ||
    //   !newProps.data.BusinessUserProfileData.transcardAccount
    // ) {
    //   !newProps.data.BusinessUserProfileData.transcardAccount ||
    //   newProps.data.BusinessUserProfileData.transcardAccount == "No"
    //     ? this.setState({ transcardAccountState: false })
    //     : this.setState({ transcardAccountState: true });
    // }

    if (newProps.recieveGetTranscardPaymentMethods) {
      this.setState({
        showLinkButton: true,
      });
    }
    if (
      !this.props.recieveDisburseAmount.code &&
      newProps.recieveDisburseAmount.code
    ) {
      if (newProps.recieveDisburseAmount.code == "200") {
        this.setState(
          {
            transferFundsToACHState:
              this.state.transcardAccountState == true ? true : false,
            transferFundsToCardState:
              this.state.transcardCardState == true ? true : false,
          },
          () => {
            const data = {
              userId: localStorage.getItem("userId"),
              paymentId: newProps.recieveDisburseAmount.result,
              debitedAmount: this.state.walletBalance,
              transferMode: this.state.transcardAccountState
              ? "ACH"
              : "Instant Transfer",
            };
            if (
              this.state.transcardAccountState == true &&
              this.state.transcardCardState == false
            ) {
              this.props.transferFundsToACH({ data });
            }
            if (
              this.state.transcardAccountState == false &&
              this.state.transcardCardState == true
            ) {
              this.props.transferFundsToCard({ data });
            }
          }
        );
      } else if (
        newProps.data.recieveDisburseAmount.code == "400" &&
        this.state.isLoader == true
      ) {
        this.setState({
          isLoader: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    if (
      this.state.transferFundsToCardState &&
      newProps.receiveTransferFundsToCard
    ) {
      if (
        newProps.receiveTransferFundsToCard.code == "200" &&
        this.state.debitWalletBalanceState !== true
      ) {
        this.setState(
          {
            debitWalletBalanceState: true,
          },
          () => {
            this.props.getDebitWalletBalance({
              userId: localStorage.getItem("userId"),
              debitedAmount: this.state.walletBalance,
              transferMode: this.state.transcardAccountState
                ? "ACH"
                : "Instant Transfer",
            });
          }
        );
      } else if (
        newProps.data.receiveTransferFundsToCard.code == "400" &&
        this.state.isLoader == true
      ) {
        this.setState({
          isLoader: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    if (
      this.state.transferFundsToACHState &&
      newProps.receiveTransferFundsToACH
    ) {
      if (
        newProps.receiveTransferFundsToACH.code == "200" &&
        this.state.debitWalletBalanceState !== true
      ) {
        this.setState(
          {
            debitWalletBalanceState: true,
          },
          () => {
            this.props.getDebitWalletBalance({
              userId: localStorage.getItem("userId"),
              debitedAmount: this.state.walletBalance,
              transferMode: this.state.transcardAccountState
                ? "ACH"
                : "Instant Transfer",
              roleName: this.state.roleName,
            });
          }
        );
      } else if (
        newProps.data.receiveTransferFundsToACH.code == "400" &&
        this.state.isLoader == true
      ) {
        this.setState({
          isLoader: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    if (
      this.state.debitWalletBalanceState &&
      newProps.data.getDebitWalletBalance
    ) {
      if (newProps.data.getDebitWalletBalance.code == "200") {
        this.setState({
          isLoader: false,
          debitWalletBalanceState: false,
          transferFundsToACHState: false,
          transferFundsToCardState: false,
        });
        toast.success("Funds Successfully Transfered", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.getUserTransactionsHistory(localStorage.getItem("userId"));
        this.props.clearRecieveDisburseAmount();
        this.props.clearReceiveTransferFundsToACH();
        this.props.cleargetDebitWalletBalance();
      } else if (
        newProps.data.getDebitWalletBalance.code == "400" &&
        this.state.isLoader == true
      ) {
        this.setState({
          isLoader: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }

    if (
      this.props.recieveLinkAccountProfile.setAt !==
      newProps.recieveLinkAccountProfile.setAt
    ) {
      if (linkCode && linkCode != "undefined") {
        if (linkCode == "200") {
          this.setState(
            {
              // linkAccountStep1: false,
              addUserBankAccountState: true,
              transcardAccountState: true,
            },
            () => {
              const data = {
                userId: localStorage.getItem("userId"),
                accountHolderName: this.state.accountHolderName,
                accountNumber: this.state.accountNumber,
                routingNumber: this.state.routingNumber,
                accountType: this.state.accountType,
                displayName: this.state.displayName,
              };
              this.props.addUserBankAccount({ data });
            }
          );
        }
        if (linkCode == "400") {
          this.setState(
            {
              isLoader: false,
              linkAccountStep1: false,
              linkCardAccountStep1: false,
              addAccountStep1: false,
              addCardAccountStep1: false,
              bankAccountConfirmationPopup: false,
              addMultipleAccountState: false,
              checkboxState: false,
              viewAccountState: false,
              errorCheckbox: true,
              accountHolderName: "",
              accountNumber: "",
              routingNumber: "",
              accountType: "",
              displayName: "",
              value: "1",
              routingNumberError: "",
              accountNumberError: "",
              address1Popup: "",
              address2Popup: "",
              cityPopup: "",
              statePopup: "",
              statePopupError: "",
              stateCardPopupError: "",
              stateCardPopup: "",
              zipPopup: "",
              address1PopupError: "",
              address2PopupError: "",
              cityPopupError: "",
              zipPopupError: "",
              zipCodeError: "",
              stateError: "",
              statePopupName: "",
              stateCardPopupName: "",
              cardValue: "1",
              address1CardPopup: "",
              address2CardPopup: "",
              cityCardPopup: "",
              zipCardPopup: "",
              address1CardPopupError: "",
              address2CardPopupError: "",
              cityCardPopupError: "",
              zipCardPopupError: "",
              zipCardCodeError: "",
              achState: false,
              instantTransferState: false,
              addressNextButton: false,
              addressCardNextButton: false,
              nextButtonStepActive: false,
              nextCardButtonStepActive: false,
              cardFirstName: "",
              cardFirstNameError: false,
              cardLastName: "",
              cardLastNameError: false,
              cardNickName: "",
              cardNickNameError: false,
              cardNumber: "",
              cardNumberError: false,
              cardMonth: "",
              cardMonthError: false,
              cardYear: "",
              cardYearError: false,
              cardCvv: "",
              cardCvvError: false,
              noAccountLinked: true,
            },
            () => {
              toast.error(
                "Transcard account already exists. Please make new account.",
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
            }
          );
        }
      }
    }
    if (
      this.props.receiveTranscardCardApi.setAt !==
      newProps.receiveTranscardCardApi.setAt
    ) {
      if (linkCardCode && linkCardCode != "undefined") {
        if (linkCardCode == "200") {
          let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
          this.setState(
            {
              // linkAccountStep1: false,
              // nextButtonStepActive: false,
              transcardCardState: true,
              transcardAccountState: false,
              addBusinessUserCardState: true,
              noCardLinked: false,
              isLoader: true,
              hasAnyActiveCard: true,
            },
            () => {
              const data = {
                userId: localStorage.getItem("userId"),
                cvc: this.state.cardCvv,
                firstName: this.state.cardFirstName,
                lastName: this.state.cardLastName,
                cardNumber: this.state.cardNumber
                  .replace(/_/g, "")
                  .replace(/ /g, ""),
                cardNickName: this.state.cardNickName,
                cardExpirationDate: cardExpirationDate,
              };
              this.props.addBusinessUserCard({ data });
            }
          );
        }
        if (linkCardCode == "400") {
          this.setState(
            {
              isLoader: false,
              linkAccountStep1: false,
              linkCardAccountStep1: false,
              addAccountStep1: false,
              addCardAccountStep1: false,
              bankAccountConfirmationPopup: false,
              addMultipleAccountState: false,
              checkboxState: false,
              viewAccountState: false,
              errorCheckbox: true,
              accountHolderName: "",
              accountNumber: "",
              routingNumber: "",
              accountType: "",
              displayName: "",
              value: "1",
              routingNumberError: "",
              accountNumberError: "",
              address1Popup: "",
              address2Popup: "",
              cityPopup: "",
              statePopup: "",
              statePopupError: "",
              stateCardPopupError: "",
              stateCardPopup: "",
              zipPopup: "",
              address1PopupError: "",
              address2PopupError: "",
              cityPopupError: "",
              zipPopupError: "",
              zipCodeError: "",
              stateError: "",
              statePopupName: "",
              stateCardPopupName: "",
              cardValue: "1",
              address1CardPopup: "",
              address2CardPopup: "",
              cityCardPopup: "",
              zipCardPopup: "",
              address1CardPopupError: "",
              address2CardPopupError: "",
              cityCardPopupError: "",
              zipCardPopupError: "",
              zipCardCodeError: "",
              achState: false,
              instantTransferState: false,
              addressNextButton: false,
              addressCardNextButton: false,
              nextButtonStepActive: false,
              nextCardButtonStepActive: false,
              cardFirstName: "",
              cardFirstNameError: false,
              cardLastName: "",
              cardLastNameError: false,
              cardNickName: "",
              cardNickNameError: false,
              cardNumber: "",
              cardNumberError: false,
              cardMonth: "",
              cardMonthError: false,
              cardYear: "",
              cardYearError: false,
              cardCvv: "",
              cardCvvError: false,
              noCardLinked: true,
            },
            () => {
              toast.error(
                "Transcard account already exists. Please make new account.",
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
            }
          );
        }
      }
    }

    if (
      (this.state.addBusinessUserCardState && newProps.receiveAddBusinessUserCard) ||
      (newProps.receiveAddBusinessUserCard && this.state.addNewCardWithoutAdd != "")
    ) {
      if (
        // !this.props.receiveAddBusinessUserCard.code &&
        newProps.receiveAddBusinessUserCard &&
        newProps.receiveAddBusinessUserCard.data &&
        newProps.receiveAddBusinessUserCard.data.code == "200" &&
        newProps.receiveAddBusinessUserCard.data.code != "406"
      ) {
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
        this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
        this.setState({
          linkAccountStep1: false,
          linkCardAccountStep1: false,
          nextCardButtonStepActive: false,
          addUserCardState: false,
          addBusinessUserCardState: false,
          transcardCardState: true,
          isLoader: false,
          isCreatedCard: true,
          AddNewCardState: false,
          addAccountStep1: false,
          addCardAccountStep1: false,
          bankAccountConfirmationPopup: false,
          addMultipleAccountState: false,
          checkboxState: false,
          viewAccountState: false,
          errorCheckbox: true,
          accountHolderName: "",
          accountNumber: "",
          routingNumber: "",
          accountType: "",
          displayName: "",
          value: "1",
          routingNumberError: "",
          accountNumberError: "",
          address1Popup: "",
          address2Popup: "",
          cityPopup: "",
          statePopup: "",
          statePopupError: "",
          stateCardPopupError: "",
          stateCardPopup: "",
          zipPopup: "",
          address1PopupError: "",
          address2PopupError: "",
          cityPopupError: "",
          zipPopupError: "",
          zipCodeError: "",
          stateError: "",
          statePopupName: "",
          stateCardPopupName: "",
          cardValue: "1",
          address1CardPopup: "",
          address2CardPopup: "",
          cityCardPopup: "",
          zipCardPopup: "",
          address1CardPopupError: "",
          address2CardPopupError: "",
          cityCardPopupError: "",
          zipCardPopupError: "",
          zipCardCodeError: "",
          achState: false,
          instantTransferState: false,
          addressNextButton: false,
          addressCardNextButton: false,
          nextButtonStepActive: false,
          cardFirstName: "",
          cardFirstNameError: false,
          cardLastName: "",
          cardLastNameError: false,
          cardNickName: "",
          cardNickNameError: false,
          cardNumber: "",
          cardNumberError: false,
          cardMonth: "",
          cardMonthError: false,
          cardYear: "",
          cardYearError: false,
          cardCvv: "",
          cardCvvError: false,
          noCardLinked: true,
        });
        toast.success("Card successfully linked!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.clearReceiveAddBusinessUserCard();
      } else if (linkCardCode == "400") {
        this.setState({
          isLoader: false,
        });
      }
      if (
        newProps.receiveAddBusinessUserCard.data &&
        newProps.receiveAddBusinessUserCard.data.code &&
        newProps.receiveAddBusinessUserCard.data.code == "406"
      ) {
        this.setState({
          linkAccountStep1: false,
          linkCardAccountStep1: false,
          nextCardButtonStepActive: false,
          addUserCardState: false,
          addBusinessUserCardState: false,
          transcardCardState: true,
          isLoader: false,
          isCreatedCard: true,
          AddNewCardState: false,
          addAccountStep1: false,
          addCardAccountStep1: false,
          bankAccountConfirmationPopup: false,
          addMultipleAccountState: false,
          checkboxState: false,
          viewAccountState: false,
          errorCheckbox: true,
          accountHolderName: "",
          accountNumber: "",
          routingNumber: "",
          accountType: "",
          displayName: "",
          value: "1",
          routingNumberError: "",
          accountNumberError: "",
          address1Popup: "",
          address2Popup: "",
          cityPopup: "",
          statePopup: "",
          statePopupError: "",
          stateCardPopupError: "",
          stateCardPopup: "",
          zipPopup: "",
          address1PopupError: "",
          address2PopupError: "",
          cityPopupError: "",
          zipPopupError: "",
          zipCodeError: "",
          stateError: "",
          statePopupName: "",
          stateCardPopupName: "",
          cardValue: "1",
          address1CardPopup: "",
          address2CardPopup: "",
          cityCardPopup: "",
          zipCardPopup: "",
          address1CardPopupError: "",
          address2CardPopupError: "",
          cityCardPopupError: "",
          zipCardPopupError: "",
          zipCardCodeError: "",
          achState: false,
          instantTransferState: false,
          addressNextButton: false,
          addressCardNextButton: false,
          nextButtonStepActive: false,
          cardFirstName: "",
          cardFirstNameError: false,
          cardLastName: "",
          cardLastNameError: false,
          cardNickName: "",
          cardNickNameError: false,
          cardNumber: "",
          cardNumberError: false,
          cardMonth: "",
          cardMonthError: false,
          cardYear: "",
          cardYearError: false,
          cardCvv: "",
          cardCvvError: false,
          noCardLinked: true,
        });
        toast.error("Display Name should be different than previous ones", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.clearReceiveAddBusinessUserCard();
      }
    }
    if (
      (this.state.addUserBankAccountState &&
        newProps.receiveAddUserBankAccountApi) ||
      (newProps.receiveAddUserBankAccountApi &&
        this.state.addNewAccWithoutAdd != "")
    ) {
      if (
        !this.props.receiveAddUserBankAccountApi.code &&
        newProps.receiveAddUserBankAccountApi.code &&
        // this.state.isCreated == false && 
        newProps.receiveAddUserBankAccountApi.code != "406"
      ) {
        this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
        this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
        this.setState({
          linkAccountStep1: false,
          transcardAccountState: true,
          addAccountStep1: false,
          // hasAnyActiveAccount: true,
          noAccountLinked: false,
          isLoader: false,
          isCreated: true,
          checkboxState: false,
          addMultipleAccountState: false,
          addNewAccWithoutAdd: "",
          accountHolderName: "",
          accountNumber: "",
          routingNumber: "",
          accountType: "",
          displayName: "",
          value: "1",
          routingNumberError: "",
          accountNumberError: "",
        });
        toast.success("Account successfully linked!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.clearReceiveAddUserBankAccountApi();
      }
    }  if (linkCode == "400") {
      this.setState({
        isLoader: false,
      });
    }  if (newProps.receiveAddUserBankAccountApi.code == "406") {
      console.log('406')
      this.setState({
        addMultipleAccountState: false,
        transcardAccountState: true,
        isLoader: false,
        AddNewBankAccountState: true,
        noAccountLinked: false,
        hasAnyActiveAccount: false,
        linkAccountStep1: false,
        linkCardAccountStep1: false,
        addAccountStep1: false,
        addCardAccountStep1: false,
        bankAccountConfirmationPopup: false,
        addMultipleAccountState: false,
        checkboxState: false,
        viewAccountState: false,
        errorCheckbox: true,
        accountHolderName: "",
        accountNumber: "",
        routingNumber: "",
        accountType: "",
        displayName: "",
        value: "1",
        routingNumberError: "",
        accountNumberError: "",
        address1Popup: "",
        address2Popup: "",
        cityPopup: "",
        statePopup: "",
        statePopupError: "",
        stateCardPopupError: "",
        stateCardPopup: "",
        zipPopup: "",
        address1PopupError: "",
        address2PopupError: "",
        cityPopupError: "",
        zipPopupError: "",
        zipCodeError: "",
        stateError: "",
        statePopupName: "",
        stateCardPopupName: "",
        cardValue: "1",
        address1CardPopup: "",
        address2CardPopup: "",
        cityCardPopup: "",
        zipCardPopup: "",
        address1CardPopupError: "",
        address2CardPopupError: "",
        cityCardPopupError: "",
        zipCardPopupError: "",
        zipCardCodeError: "",
        achState: false,
        instantTransferState: false,
        addressNextButton: false,
        addressCardNextButton: false,
        nextButtonStepActive: false,
        nextCardButtonStepActive: false,
      });
      toast.error(
        newProps.receiveAddUserBankAccountApi.collectMessage.messageShort,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      this.props.clearReceiveAddUserBankAccountApi();
    }

    // if (
    //   this.state.addNewAccWithoutAdd == 'addNewAccount' &&
    //   newProps.receiveAddUserBankAccountApi
    // ) {
    //   if (newProps.receiveAddUserBankAccountApi.code == "200") {
    //     console.log("2222")
    //     this.setState({
    //       addAccountStep1: false,
    //       linkAccountStep1: false,
    //       addMultipleAccountState: false,
    //       addNewAccWithoutAdd: '',
    //       transcardAccountState: true,
    //       hasAnyActiveAccount: true,
    //       noAccountLinked: false,
    //       isLoader: false,
    //       checkboxState: false,
    //       accountHolderName: "",
    //       accountNumber: "",
    //       routingNumber: "",
    //       accountType: "",
    //       displayName: "",
    //       value: "1",
    //       routingNumberError: "",
    //       accountNumberError: "",
    //     });
    //     toast.success(newProps.receiveAddUserBankAccountApi.collectMessage.messageShort, {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //     // this.props.getAddedBankAccountsForUser (localStorage.getItem ('userId'));
    //     this.props.clearReceiveAddUserBankAccountApi()
    //   }
    //   if(newProps.receiveAddUserBankAccountApi.code == "406") {
    //     this.setState({
    //       addAccountStep1: false,
    //       addAccountStep1: false,
    //       addMultipleAccountState: false,
    //       transcardAccountState: true,
    //       isLoader: false,
    //       checkboxState: false,
    //       accountHolderName: "",
    //       accountNumber: "",
    //       routingNumber: "",
    //       accountType: "",
    //       displayName: "",
    //       value: "1",
    //       routingNumberError: "",
    //       accountNumberError: "",
    //       AddNewBankAccountState: true,
    //       noAccountLinked: false,
    //       hasAnyActiveAccount: false,
    //     });
    //     toast.error(newProps.receiveAddUserBankAccountApi.collectMessage.messageShort, {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //     this.props.clearReceiveAddUserBankAccountApi()
    //   }
    // }
  }
  // }
  // }

   exportPDF = (datas) => {
    // const unit = "pt";
    // const size = "A4"; // Use A1, A2, A3 or A4
    // const orientation = "portrait"; // portrait or landscape

    // const marginLeft = 40;
    // const doc = new jsPDF(orientation, unit, size);
    // let doc = new jsPDF();

    // doc.setFontSize(15);

    // const title = "Report";
    // const headers = [["SETTLEMENT", "GROSS AMOUNT","COLLECTIVELY FEE","TRANSFER FEE","TYPE","NET AMOUNT","STATUS","DATE"]];

    // const data = 
    //   datas.result.records.map(transactionHistory =>(
    //       [
    //         String(transactionHistory.settlementShortName), 
    //         String(transactionHistory.priceBreakupDto.totalAmount.toFixed(
    //         2)),
    //         String(transactionHistory.priceBreakupDto.collectivelyCommissionAmount.toFixed(
    //           2
    //         )),
    //          String(transactionHistory.priceBreakupDto.transferFee.toFixed(
    //           2
    //         )),
    //         String(transactionHistory.transferMode) ,
    //         String(transactionHistory.priceBreakupDto.userAmount.toFixed(
    //           2
    //         )),
    //         "COMPLETED" ,
    //         String(transactionHistory.inProgressDate)
    //       ]
            
    //   ));
  // console.log("datas",data)
 
  //   let content = {
  //     head: headers,
  //     body: data,
  //     // startY :12
  //   };
  //   console.log(`content`, content)
  //   // doc.text(title, marginLeft, 40);
  //   doc.autoTable(content);
  //   doc.save("Report.pdf")
  }
  toggleHandlerOne = () => {
    const dual = this.state.tableState;
    this.setState({tableState:!dual});
    console.log("clicked")
  }


  render() {
    let csvReport ;
    if(this.props.receiveGetUserTransactionsHistory.data && this.props.receiveGetUserTransactionsHistory.data.result !== undefined){    //2893 fix csv and pdf
      console.log("no",this.props.receiveGetUserTransactionsHistory.data);
      const data = [
        this.props.receiveGetUserTransactionsHistory.data.result.records.map(transactionHistory =>(
            {settlement:  String(transactionHistory.settlementShortName), 
                grossamount: "$"+ String(transactionHistory.priceBreakupDto.totalAmount.toFixed(
                2)),
              collectivelyfee :"$"+  String(transactionHistory.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                2
              )),
              transferfee : "$"+ String(transactionHistory.priceBreakupDto.transferFee.toFixed(
                2
              )),
              type :  String(transactionHistory.transferMode) ,
              netamount :"$"+  String(transactionHistory.priceBreakupDto.userAmount.toFixed(
                2
              )),
              status: "COMPLETED" ,
              date : String(transactionHistory.amountTransferredDate)
            }
            
        ))
    ];
    const headers = [{
          label : "SETTLEMENT",key :"settlement"
      },
      {label:"GROSS AMOUNT",key:"grossamount"},
      {label:"COLLECTIVELY FEE",key:"collectivelyfee"},
      {label : "TRANSFER FEE",key : "transferfee"},
      {label : "TYPE" , key : "type"},
      {label:"NET AMOUNT" ,key : "netamount"},
      {label: "STATUS" ,key : "status"},
      {label:"DATE",key:"date"}
      ];
      console.log("data",data[0],headers,typeof data["settlement"])
        csvReport = {
          data: data[0],
          headers: headers,
          filename: 'Report.csv'
        };
        console.log("datan",csvReport)
    }
    const {
      errors,
      errorsFile,
      signatureDefaultValue,
      privacyPolicyPath,
      agreementLetterPath,
      letterOfAgencyPath,
      signatureFontFamily,
      showUpadeButtonR,
      showButton1,
      workCountryCode,
      countryCode,
      cCompanyName,
      recordsCompany,
      cStreeAddress,
      streeAddress2,
      cCity,
      cZipCode,
      cTaxId,
      cWebSite,
      cAcceptCC,
      cDissolvedStatus,
      cBankruptcyStatus,
      cStartingYear,
      cContactName,
      cContactEmail,
      cContactNumber,
      otherIndustryType,
      // cEin,
      cEntityName,
      bankruptcyStatus,
      CompanyForm,
      file,
      firstName,
      lastName,
      companyTitle,
      workPhoneNumber,
      email,
      companyName,
      streeAddress,
      dissolvedStatus,
      acceptCC,
      city,
      zipCode,
      taxId,
      webSite,
      state,
      isLoader,
      mobilePhone,
      cState,
      industryTypeId,
      cIndustryTypeId,
      cOtherIndustryType,
      separateTaxId,
      totalTaxId,
      startingYear,
      uploadForm,
      walletBalance,
      cardFirstName,
      cardLastName,
      cardNickName,
      cardErrors,
      cardNumber,
      cardMonth,
      cardYear,
      cardCvv,
    } = this.state;

    const {
      AllStates,
      AllCountryData,
      IndustryData,
      ChidCompanyData,
      GetBusinessSubUserList,
    } = this.props.data;

    const options = [];
    options.push({ value: "", label: "State", name: "state" });
    AllStates.map((item) =>
      options.push({
        value: item.stateId,
        label: item.stateName,
        name: item.stateName,
      })
    );

    const selectedArra = _.find(options, { value: state });
    const defaultOption = selectedArra;

    const cSelectedArra = _.find(options, { value: cState });
    const sDefaultOption = cSelectedArra;

    const IndustryDataoptions = [];
    IndustryDataoptions.push({
      value: "",
      label: "Industry",
      name: "Industry",
    });
    IndustryData.map((item) =>
      IndustryDataoptions.push({
        value: item.lookupTypeValueId,
        label: item.displayText,
        name: item.displayText,
      })
    );

    // selecting the first index to select
    const selectedIndustry = _.find(IndustryDataoptions, {
      value: industryTypeId,
    });
    const defaultOptionIndustry = selectedIndustry;

    const cSelectedIndustry = _.find(IndustryDataoptions, {
      value: cIndustryTypeId,
    });
    const cDefaultOptionIndustry = cSelectedIndustry;

    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map((item) =>
        optionsCountry.push({
          value: item.countryCode,
          label: item.countryCode,
          name: item.countryCode,
        })
      );
    } else {
      optionsCountry.push({ value: "+1", label: "+1", name: "+1" });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: countryCode });
    const cDefaultOptionCountry = cSelectedCountry;

    const cSelectedCountryWork = _.find(optionsCountry, {
      value: workCountryCode,
    });
    const cDefaultOptionWorkCodeCountry = cSelectedCountryWork;

    const optionsSince = [];
    optionsSince.push({
      value: "",
      label: "Year your business started",
      name: "Since",
    });
    optionsSince.push({
      value: "Prior to 1990",
      label: "Prior to 1990",
      name: "Since",
    });

    const currentDate = new Date().getFullYear();
    for (let i = 1990; i <= currentDate; i++) {
      optionsSince.push({ value: i.toString(), label: i, name: i });
    }
    // selecting the first index to select
    const cSelectedSince3 = _.find(optionsSince, { value: startingYear });
    const cDefaultSince3 = cSelectedSince3;

    const cSelectedSince2 = _.find(optionsSince, { value: cStartingYear });
    const cDefaultSince2 = cSelectedSince2;

    // BusinessUserData
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <div className="wp-tab-container">
        <h3 className="p-w-h3">Profile</h3>
        <Tabs>
          <TabList>
            <Tab>Settings</Tab>
            <Tab
              className={
                this.state.walletBalance != 0
                  ? "react-tabs__tab greenDotActive"
                  : "react-tabs__tab"
              }
            >
              Wallet
            </Tab>
          </TabList>

          <TabPanel>
            <span className="business-profile">
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <Modal
                shouldCloseOnOverlayClick={false}
                isOpen={this.state.modalIsDebite}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalDebite}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="modal-content addvehicle-content">
                  <div className="col s12 m7">
                    <h4> Wallet </h4>
                  </div>
                  <div className="col s12">
                    <div className="grey-box">
                      <div className="grey-inner">
                        <p> Are you sure you want to debit this amount ?</p>
                        <button
                          onClick={this.debitWalletBalance}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Yes
                          <i className="material-icons">arrow_forward</i>
                        </button>

                        <button
                          onClick={this.closeModalDebite}
                          style={{ marginLeft: "5px" }}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          No
                          <i className="material-icons">arrow_forward</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              {/* Linked Bank Account Popup  Starts Here*/}

              {/* <Modal
          isOpen={this.state.viewAccountState}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalResidences}
          style={linkedAccCustomStyles}
          contentLabel="test"
          ariaHideApp={false}
        >
          <div className="lined-acc-table">
            <h3 className="popupAddBank">Linked Accounts</h3>
              <table className="table-simple">
                    <thead>
                      <tr>
                        <th>Display Name</th>
                        <th>Added on</th>
                        <th>Action</th>
                       
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.receiveGetAddedBankAccountsForUser && this.props.receiveGetAddedBankAccountsForUser.code == '200' && this.props.receiveGetAddedBankAccountsForUser.result.map(bankAcc => (
                        <tr>
                        <td data-column="Display Name">{bankAcc.accountDisplayName}</td>
                        <td data-column="Add on">{moment(bankAcc.createdAt).format('ll')}</td>
                        <td data-column="Action"> 
                         <button className="btn waves-effect waves-light primary-danger table-btn " type="button" disabled={bankAcc.defaultAccount == true ? true : false} value={bankAcc.id} onClick={this.removeBankAccount} name="remove">Remove</button>
                         <button className={bankAcc.defaultAccount == true ? "btn waves-effect waves-light primary-green table-btn " : "btn waves-effect waves-light primary-default  table-btn "} onClick={this.makeDefaultAccount} type="button" value={bankAcc.id} name={bankAcc.defaultAccount == true ? "Default" : "Make Default"}>{bankAcc.defaultAccount == true ? "Default" : "Make Default"}</button>
                         </td>
                       
                        </tr>
                      ))}
                     
                    </tbody>    
                  </table>
                  <button
                      // disabled={!isEmpty(errors)}
                      className={" waves-effect waves-light pink-btn btn-tab"}
                      type="button"
                      onClick={this.handleCancel}
                      name="cancel"
                    >
                      Close
                  </button>
          </div>
        </Modal>

 */}

              {/* Linked Bank Account Popup  Starts Here*/}

              {/* Add Account Popup  Starts Here*/}
              <Modal
                isOpen={this.state.addAccountStep1}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalResidences}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="row consumer-tab-info ibmfont signup-new-tabs">
                  <div className="col s12">
                    <LinkAccountStep2
                      onChangeStep2={this.onChangeStep2}
                      onChangeStep2Select={this.onChangeStep2Select}
                      handlePopupSubmit={this.handlePopupSubmit}
                      routingNumber={this.state.routingNumber}
                      accountNumber={this.state.accountNumber}
                      accountType={this.state.accountType}
                      accountHolderName={this.state.accountHolderName}
                      displayName={this.state.displayName}
                      accountHolderNameError={this.state.accountHolderNameError}
                      displayNameError={this.state.displayNameError}
                      accountNumberError={this.state.accountNumberError}
                      routingNumberError={this.state.routingNumberError}
                      accountTypeError={this.state.accountTypeError}
                      onClick={this.handleCancel}
                      addMultipleAccountState={
                        this.state.addMultipleAccountState
                      }
                    />
                    <button
                      // disabled={!isEmpty(errors)}
                      className={
                        !isEmpty(errors)
                          ? " waves-effect waves-light ltgrey-btn btn-tab"
                          : " waves-effect waves-light pink-btn btn-tab"
                      }
                      type="button"
                      onClick={this.handleCancel}
                      name="cancel"
                    >
                      Cancel
                    </button>
                    <button
                      disabled={
                        this.state.createAccEnable == false ? true : false
                      }
                      className={
                        this.state.createAccEnable == false
                          ? " waves-effect waves-light ltgrey-btn btn-tab"
                          : " waves-effect waves-light pink-btn btn-tab"
                      }
                      type="submit"
                      onClick={this.handlePopupSubmit}
                      name="back"
                    >
                      Create Account
                    </button>
                  </div>
                </div>
              </Modal>

              {/* Add Account Popup  Ends Here*/}

              {/* Disburse Amount Popup starts here */}

              <Modal
                isOpen={this.state.disburseAmountPopupState}
                onAfterOpen={this.openDisbursePopup}
                onRequestClose={this.closeDisbursePopup}
                style={customStylesDisburse}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="modal-content addvehicle-content disburse-box">
                  <div className="col s12 m7">
                    <h4> Disburse Amount </h4>
                  </div>
                  <div className="col s12">
                    <div className="grey-box">
                      <div className="grey-inner">
                        <p>
                          {" "}
                          Your wallet balance of $
                          {this.state.walletBalance &&
                            this.state.walletBalance.toFixed(2)}{" "}
                          will be transferred to your bank acc, would you like
                          to proceed ?
                        </p>
                        <button
                          onClick={this.disburseAmount}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Proceed
                          <i className="material-icons">arrow_forward</i>
                        </button>

                        <button
                          onClick={this.closeDisbursePopup}
                          style={{ marginLeft: "5px" }}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Cancel
                          <i className="material-icons">arrow_forward</i>
                        </button>
                      </div>
                      <Link
                        to={"/profile"}
                        onClick={this.viewAccountsPopup}
                        className=""
                      >
                        Change Account
                      </Link>
                    </div>
                  </div>
                </div>
              </Modal>

              {/* Disburse amount popup ends here */}

              {/* Link Account Popup  Starts Here*/}

              <Modal
                isOpen={this.state.linkAccountStep1}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalResidences}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="row consumer-tab-info ibmfont signup-new-tabs">
                  <div className="col s12">
                    <TabContext1 value={this.state.value}>
                      <AppBar position="static">
                        <TabList1
                          onChange={this.handleChange}
                          aria-label="simple tabs example"
                        >
                          <Tab1 label="Step 1" value="1" />
                          <Tab1 label="Step 2" value="2" />
                        </TabList1>
                      </AppBar>
                      <TabPanel1 value="1">
                        <LinkAccountStep1
                          handleCheckBoxFirstStep={this.handleCheckBoxFirstStep}
                          checkboxState={this.state.checkboxState}
                          onChange={this.onChange}
                          recieveGetTranscardPaymentMethods={
                            this.props.data.recieveGetTranscardPaymentMethods
                          }
                        />
                        <div className="row row-margin">
                          {/* <div className="col s12">
                      <p className="left-align">
                        Download template{" "}
                        <a className="" href={csvFile} target="_blank">
                          CSV{" "}
                        </a>{" "}
                        /{" "}
                        <a className="" href={xlsxFile} target="_blank">
                          Excel{" "}
                        </a>
                        Format of CSV/Excel file must match the template.
                      </p>
                    </div> */}
                          {/* <div className="col s7">
                      <p className="right-align">
                        Format of CSV/Excel file must match the template.
                      </p>
                    </div> */}
                        </div>
                        <div className="input-field full-field save-button">
                          <button
                            className={
                              "waves-effect waves-light pink-btn btn-tab "
                            }
                            type="button"
                            onClick={this.handleCancel}
                            name="cancel"
                          >
                            Cancel
                          </button>
                          <button
                            className=" waves-effect waves-light pink-btn btn-tab"
                            type="submit"
                            onClick={this.handleSubmitNext}
                            name="next"
                          >
                            Next
                          </button>
                        </div>
                      </TabPanel1>
                      <TabPanel1 value="2">
                        <LinkAccountStep2
                          onChangeStep2={this.onChangeStep2}
                          onChangeStep2Select={this.onChangeStep2Select}
                          handlePopupSubmit={this.handlePopupSubmit}
                          routingNumber={this.state.routingNumber}
                          accountNumber={this.state.accountNumber}
                          accountType={this.state.accountType}
                          accountHolderName={this.state.accountHolderName}
                          displayName={this.state.displayName}
                          accountHolderNameError={
                            this.state.accountHolderNameError
                          }
                          displayNameError={this.state.displayNameError}
                          accountNumberError={this.state.accountNumberError}
                          routingNumberError={this.state.routingNumberError}
                          accountTypeError={this.state.accountTypeError}
                          addMultipleAccountState={
                            this.state.addMultipleAccountState
                          }
                          onClick={this.handleCancel}
                        />
                        <button
                          // disabled={!isEmpty(errors)}
                          className={
                            !isEmpty(errors)
                              ? " waves-effect waves-light ltgrey-btn btn-tab w-cancel"
                              : " waves-effect waves-light pink-btn btn-tab w-cancel"
                          }
                          type="submit"
                          onClick={this.handleCancel}
                          name="cancel"
                        >
                          Cancel
                        </button>
                        <button
                          disabled={
                            this.state.createAccEnable == false ? true : false
                          }
                          className={
                            this.state.createAccEnable == false
                              ? " waves-effect waves-light ltgrey-btn btn-tab w-submit"
                              : " waves-effect waves-light pink-btn w-btn-blue btn-tab  w-submit"
                          }
                          type="submit"
                          onClick={this.handlePopupSubmit}
                          name="back"
                        >
                          Create Account
                        </button>
                      </TabPanel1>
                    </TabContext1>
                  </div>
                </div>
              </Modal>

              {/* Link Account Popup  Ends Here*/}

              <ToastsContainer
                store={ToastsStore}
                className="toast-error-msg"
                position={ToastsContainerPosition.TOP_CENTER}
                lightBackground
              />
              {loader1}
              {localStorage.getItem("roleName") !== "Business-SubUser" ? (
                <div>
                  <div className="sub-categorymain">
                    <Modal
                      shouldCloseOnOverlayClick={false}
                      isOpen={this.state.modalIsOpenSubUserDelete}
                      onAfterOpen={this.afterOpenModal}
                      onRequestClose={this.closeModalSubUserDelete}
                      style={customStyles}
                      contentLabel="test"
                      ariaHideApp={false}
                    >
                      <div className="modal-content addvehicle-content">
                        <div className="col s12 m7">
                          <h4>Business Entities</h4>
                        </div>
                        <div className="col s12">
                          <div className="grey-box">
                            <div className="grey-inner">
                              <p>
                                {" "}
                                Are you sure want to delete business entity ?{" "}
                              </p>
                              <button
                                onClick={this.handleDeleteYSubuser}
                                className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                                type="submit"
                                name="action"
                              >
                                Yes
                                <i className="material-icons">arrow_forward</i>
                              </button>

                              <button
                                onClick={this.closeModalSubUserDelete}
                                style={{ marginLeft: "5px" }}
                                className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                                type="submit"
                                name="action"
                              >
                                No
                                <i className="material-icons">arrow_forward</i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>

                    <Modal
                      shouldCloseOnOverlayClick={false}
                      isOpen={this.state.CompanyForm}
                      onAfterOpen={this.afterOpenModal}
                      onRequestClose={this.closeCompanyForm}
                      style={customCompanyStyles}
                      className="businesscompany"
                      contentLabel="test"
                      ariaHideApp={false}
                    >
                      <div className="modal-content addvehicle-content add-companymodaltop">
                        <h4 className="m-hdng">Company Information </h4>
                        <form className="company-form">
                          <div className="manage-copmpany-lt">
                            <div className="input-field  half-field padding-field">
                              <TextFieldGroup
                                field="cCompanyName"
                                label="Full Company Name/DBA*"
                                value={cCompanyName}
                                error={errors.cCompanyName}
                                onChange={this.onChange}
                              />
                            </div>
                            <div className="input-field  half-field">
                              <TextFieldGroup
                                field="cStreeAddress"
                                label="Street Address*"
                                value={cStreeAddress}
                                error={errors.cStreeAddress}
                                onChange={this.onChange}
                              />
                            </div>

                            <div className="input-field  half-field padding-field">
                              <TextFieldGroup
                                field="cContactName"
                                label="Contact Name*"
                                value={cContactName}
                                error={errors.cContactName}
                                onChange={this.onChange}
                              />
                            </div>
                            <div className="input-field  half-field">
                              <MaskInputNumber
                                field="cContactNumber"
                                label="Contact Number*"
                                value={cContactNumber}
                                error={errors.cContactNumber}
                                onChange={this.onChange}
                              />
                            </div>

                            <div className="input-field  half-field padding-field">
                              <TextFieldGroup
                                field="cEntityName"
                                label="Entity Name/DBA*"
                                value={cEntityName}
                                error={errors.cEntityName}
                                onChange={this.onChange}
                              />
                            </div>
                            {/* <div className="input-field  half-field">
                    <TextFieldGroup
                      field="cEin"
                      label="Ein*"
                      value={cEin}
                      error={errors.cEin}
                      onChange={this.onChange}
                    />
                  </div> */}

                            <div className="input-field  half-field">
                              <TextFieldGroup
                                field="cCity"
                                label="City*"
                                value={cCity}
                                error={errors.cCity}
                                onChange={this.onChange}
                              />
                            </div>

                            <div className="input-field  half-field padding-field">
                              <label className="active label-profile">
                                State*
                              </label>
                              <Dropdown
                                name="cState"
                                className="browser-default"
                                options={options}
                                onChange={this._conSelect}
                                value={sDefaultOption}
                                placeholder="Select"
                              />
                              <span
                                className={errors.cStateError ? "show" : "hide"}
                              >
                                {errors.cState}
                              </span>
                            </div>

                            <div className="input-field  half-field">
                              <TextFieldGroup
                                field="cZipCode"
                                label="Zip Code*"
                                value={cZipCode}
                                error={errors.cZipCode}
                                onChange={this.onChange}
                              />
                            </div>

                            <div className="input-field  half-field padding-field">
                              <MaskInputEinNumber
                                field="cTaxId"
                                label="Tax ID (EIN)*"
                                value={cTaxId}
                                error={errors.cTaxId}
                                onChange={this.onChange}
                              />
                            </div>

                            <div className="input-field  full-field ">
                              <TextFieldGroup
                                field="cContactEmail"
                                label="Contact Email*"
                                value={cContactEmail}
                                error={errors.cContactEmail}
                                onChange={this.onChange}
                              />
                            </div>

                            <div className="input-field  full-field padding-field">
                              <TextFieldGroup
                                field="cWebSite"
                                label="Website"
                                value={cWebSite}
                                error={errors.cWebSite}
                                onChange={this.onChange}
                              />
                            </div>
                            <div className=" full-field padding-field">
                              <p>Accept CC</p>
                              <p className="radio-outer">
                                <label>
                                  <input
                                    className="with-gap"
                                    name="cAcceptCC"
                                    onChange={this.onChange}
                                    checked={cAcceptCC === "Y"}
                                    value="Y"
                                    type="radio"
                                  />
                                  <span>Yes</span>
                                </label>
                                <label>
                                  <input
                                    className="with-gap"
                                    name="cAcceptCC"
                                    onChange={this.onChange}
                                    checked={cAcceptCC === "N"}
                                    value="N"
                                    type="radio"
                                  />
                                  <span>No</span>
                                </label>
                                <span
                                  className={
                                    errors.cAcceptCCError ? "show" : "hide"
                                  }
                                >
                                  {errors.cAcceptCC}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className=" manage-copmpany-rt">
                            <div className="input-field">
                              <div className="input-field half-field ">
                                <label className="active label-profile">
                                  Industry Type
                                </label>
                                <Dropdown
                                  className="browser-default"
                                  options={IndustryDataoptions}
                                  onChange={this._conSelectForYears}
                                  value={cDefaultOptionIndustry}
                                  placeholder="Select"
                                />
                                <span
                                  className={
                                    errors.cIndustryTypeId ? "show" : "hide"
                                  }
                                >
                                  {errors.cIndustryTypeId}
                                </span>
                              </div>

                              <div className="input-field half-field padding-field">
                                <label className="active label-profile">
                                  Year your business started
                                </label>
                                <Dropdown
                                  name="cState"
                                  className="browser-default"
                                  options={optionsSince}
                                  onChange={this._cSince2}
                                  value={cDefaultSince2}
                                  placeholder="Select an option*"
                                />
                                <span
                                  className={
                                    errors.cStartingYearError
                                      ? "show invalid"
                                      : "hide"
                                  }
                                >
                                  {errors.cStartingYear}
                                </span>
                              </div>
                            </div>
                            {cIndustryTypeId === 119 ? (
                              <div className="input-field  full-field padding-field">
                                <TextFieldGroup
                                  field="cOtherIndustryType"
                                  label="Other Industry*"
                                  value={cOtherIndustryType}
                                  error={errors.cOtherIndustryType}
                                  onChange={this.onChange}
                                />
                              </div>
                            ) : (
                              ""
                            )}

                            <div className=" full-field sub-companyform">
                              <p>
                                Did the company file for bankruptcy since
                                1/1/04?
                              </p>
                              <p className="radio-outer">
                                <label>
                                  <input
                                    className="with-gap"
                                    name="cBankruptcyStatus"
                                    onChange={this.onChange}
                                    type="radio"
                                    checked={cBankruptcyStatus === "Y"}
                                    value="Y"
                                  />
                                  <span>Yes</span>
                                </label>
                                <label>
                                  <input
                                    className="with-gap"
                                    name="cBankruptcyStatus"
                                    onChange={this.onChange}
                                    type="radio"
                                    checked={cBankruptcyStatus === "N"}
                                    value="N"
                                  />
                                  <span>No</span>
                                </label>
                                <span
                                  className={
                                    errors.cBankruptcyStatusError
                                      ? "show"
                                      : "hide"
                                  }
                                >
                                  {errors.cBankruptcyStatus}
                                </span>
                              </p>
                            </div>

                            <div className="col s12 full-field sub-companyform">
                              <p>Did the company dissolve since 1/1/04?</p>
                              <p className="radio-outer">
                                <label>
                                  <input
                                    className="with-gap"
                                    name="cDissolvedStatus"
                                    onChange={this.onChange}
                                    checked={cDissolvedStatus === "Y"}
                                    value="Y"
                                    type="radio"
                                  />
                                  <span>Yes</span>
                                </label>
                                <label>
                                  <input
                                    className="with-gap"
                                    name="cDissolvedStatus"
                                    onChange={this.onChange}
                                    checked={cDissolvedStatus === "N"}
                                    value="N"
                                    type="radio"
                                  />
                                  <span>No</span>
                                </label>
                                <span
                                  className={
                                    errors.cDissolvedStatusError
                                      ? "show"
                                      : "hide"
                                  }
                                >
                                  {errors.cDissolvedStatus}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="input-field full-field save-button">
                            <button
                              onClick={this.handleSubmitCompanyChild}
                              className={
                                showButton1 === true
                                  ? "btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                                  : "hide"
                              }
                              type="submit"
                              name="action"
                            >
                              Save
                              <i className="material-icons">arrow_forward</i>
                            </button>
                            <button
                              onClick={this.handleUpdateCompanyChild}
                              className={
                                showUpadeButtonR === true
                                  ? "btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                                  : "hide"
                              }
                              type="submit"
                              name="action"
                            >
                              Update
                              <i className="material-icons">arrow_forward</i>
                            </button>

                            <button
                              onClick={this.closeCompanyForm}
                              className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                              type="submit"
                              name="action"
                            >
                              Cancel
                              <i className="material-icons">arrow_forward</i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </Modal>

                    <Modal
                      shouldCloseOnOverlayClick={false}
                      isOpen={uploadForm}
                      onAfterOpen={this.afterOpenModal}
                      onRequestClose={this.closeUploadForm}
                      style={customCompanyStyles}
                      className="businesscompany upload-child-outer"
                      id="csv-upload"
                      contentLabel="test"
                      ariaHideApp={false}
                    >
                      <div className="modal-content addvehicle-content add-companymodaltop">
                        <h4 className="m-hdng">Upload CSV/Excel</h4>
                        <form className="company-form">
                          <div className="manage-copmpany-lt upload-company-child">
                            <div className="input-field padding-field">
                              <UploadFilesGroup
                                type="file"
                                name="file"
                                label="Upload CSV/Excel"
                                id="uploadCsvFile"
                                onChange={this.handleChangeFile}
                                error={errorsFile.file}
                              />
                            </div>
                            <div className="row row-margin">
                              <div className="col s12">
                                <p className="left-align">
                                  Download template{" "}
                                  <a
                                    className=""
                                    href={csvFile}
                                    target="_blank"
                                  >
                                    CSV{" "}
                                  </a>{" "}
                                  /{" "}
                                  <a
                                    className=""
                                    href={xlsxFile}
                                    target="_blank"
                                  >
                                    Excel{" "}
                                  </a>
                                  Format of CSV/Excel file must match the
                                  template.
                                </p>
                              </div>
                              {/* <div className="col s8">
                          <p className="right-align">
                            Format of CSV/Excel file must match the template.
                          </p>
                        </div> */}
                            </div>
                          </div>
                          <div className="input-field full-field save-button">
                            <button
                              onClick={this.uploadChildCompnayCsv}
                              className="btn waves-effect waves-light primary-btn col s12 "
                              type="button"
                            >
                              Upload
                              <i className="material-icons">arrow_forward</i>
                            </button>
                            <button
                              onClick={this.closeUploadForm}
                              className="btn waves-effect waves-light primary-btn col s12 "
                              type="submit"
                              name="action"
                            >
                              Cancel
                              <i className="material-icons">arrow_forward</i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </Modal>
                  </div>
                  <div className="row section-content">
                    <div className="">
                      <div className="dashboard my-profile">
                        <div className="dashboard-tabs">
                          <div className="dashboard-bg settlement-dashboardbg">
                            <BannerHead title="Profile" />
                          </div>

                          <Link
                            className="waves-light btn btn-blue save-changes p-save-btn "
                            to={
                              GetBusinessSubUserList !== undefined
                                ? GetBusinessSubUserList.length > 0
                                  ? "/manageSubUsersBusiness"
                                  : "/addSubUsersBusiness"
                                : ""
                            }
                          >
                            Manage Other Users
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col s12">
                      <form
                        className="profile-form"
                        onSubmit={this.handleSubmitBusiness}
                      >
                        <div className="row profile-formmain">
                          <div className="col s12 m12 l6">
                            <div className="row">
                              <h5 className="tab-heading col s12 blue-heading">
                                Company Information
                              </h5>
                              <div className="row">
                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    field="companyName"
                                    label="Full Company Name/DBA*"
                                    value={companyName}
                                    error={errors.companyName}
                                    onChange={this.onChange}
                                  />
                                </div>
                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    field="streeAddress"
                                    label="Street Address*"
                                    value={streeAddress}
                                    error={errors.streeAddress}
                                    onChange={this.onChange}
                                  />
                                </div>

                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    field="streeAddress2"
                                    label="Street Address 2"
                                    value={streeAddress2}
                                    error={errors.streeAddress2}
                                    onChange={this.onChange}
                                  />
                                </div>

                                <div className="input-field col s12 m6">
                                  <label className="active">State*</label>
                                  <Dropdown
                                    name="state"
                                    className="browser-default"
                                    options={options}
                                    onChange={this._onSelect}
                                    value={defaultOption}
                                    placeholder="Select"
                                  />
                                  <span
                                    className={
                                      errors.stateError ? "show" : "hide"
                                    }
                                  >
                                    {errors.state}
                                  </span>
                                </div>
                                <div className="input-field col s12 m6">
                                  <TextFieldGroup
                                    field="city"
                                    label="City*"
                                    value={city}
                                    error={errors.city}
                                    onChange={this.onChange}
                                  />
                                </div>

                                <div className="input-field col s12 m6 clear">
                                  <TextFieldGroup
                                    field="zipCode"
                                    label="Zip Code*"
                                    value={zipCode}
                                    error={errors.zipCode}
                                    onChange={this.onChange}
                                  />
                                </div>

                                <div className="input-field col s12 m6">
                                  <MaskInputEinNumber
                                    field="taxId"
                                    label="Tax ID (EIN)*"
                                    value={taxId}
                                    error={errors.taxId}
                                    onChange={this.onChange}
                                  />
                                </div>
                                {/* <div className="col s12 company-business"> */}
                                {/* <p className="company-business-p"> */}
                                {/* To help provide you with the best solutions, please choose the size of your company. */}

                                {/* </p> */}

                                {/* <p className="radio-outer"> */}
                                {/* <label> */}
                                {/* <input */}
                                {/* className="with-gap" */}
                                {/* name="enterpriseType" */}
                                {/* onChange={this.onChange} */}
                                {/* type="radio" */}
                                {/* value="S" */}
                                {/* checked={enterpriseType === 'S'} */}
                                {/* /> */}
                                {/* <span>Small Medium Business (SMB)</span> */}
                                {/* </label> */}
                                {/* <label> */}
                                {/* <input */}
                                {/* className="with-gap" */}
                                {/* name="enterpriseType" */}
                                {/* onChange={this.onChange} */}
                                {/* type="radio" */}
                                {/* value="E" */}
                                {/* checked={enterpriseType === 'E'} */}

                                {/* /> */}
                                {/* <span>Large Enterprise</span> */}
                                {/* </label> */}
                                {/* </p> */}

                                {/* </div> */}

                                <div className="col s12 company-business">
                                  <p className="company-business-p">
                                    If the company have additional businesses or
                                    company locations with separate Tax id?*
                                  </p>

                                  <p className="radio-outer">
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="separateTaxId"
                                        onChange={this.onChange}
                                        type="radio"
                                        disabled
                                        checked={separateTaxId === "yes"}
                                        value="yes"
                                      />
                                      <span>Yes</span>
                                    </label>
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="separateTaxId"
                                        onChange={this.onChange}
                                        type="radio"
                                        disabled
                                        checked={separateTaxId === "no"}
                                        value="no"
                                      />
                                      <span>No</span>
                                    </label>
                                  </p>
                                  <div
                                    className={
                                      errors.separateTaxIdError
                                        ? "show invalid clear"
                                        : "hide"
                                    }
                                  >
                                    {errors.separateTaxId}
                                  </div>
                                  <p className="company-business-p">
                                    Please{" "}
                                    <a
                                      href="https://collectively.zendesk.com/hc/en-us/requests/new"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {" "}
                                      contact support{" "}
                                    </a>{" "}
                                    in order to add additional EINs to your
                                    profile.
                                  </p>
                                </div>
                                <div
                                  className={
                                    separateTaxId === "yes"
                                      ? "input-field col s12"
                                      : "hide"
                                  }
                                >
                                  <TextFieldGroup
                                    field="totalTaxId"
                                    label="How Many *"
                                    value={totalTaxId}
                                    error={errors.totalTaxId}
                                    onChange={this.onChangeTaxId}
                                    disable
                                  />
                                </div>
                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    field="webSite"
                                    label="Website"
                                    value={webSite}
                                    error={errors.webSite}
                                    onChange={this.onChange}
                                  />
                                </div>
                                <div className="col s12">
                                  <p>Accept CC*</p>
                                  <p className="radio-outer">
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="acceptCC"
                                        onChange={this.onChange}
                                        checked={acceptCC === "Y"}
                                        value="Y"
                                        type="radio"
                                      />
                                      <span>Yes</span>
                                    </label>
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="acceptCC"
                                        onChange={this.onChange}
                                        checked={acceptCC === "N"}
                                        value="N"
                                        type="radio"
                                      />
                                      <span>No</span>
                                    </label>
                                  </p>
                                  <div
                                    className={
                                      errors.acceptCCError
                                        ? "show invalid clear"
                                        : "hide"
                                    }
                                  >
                                    {errors.acceptCC}
                                  </div>
                                </div>

                                <div className="input-field col s12 ">
                                  <label className="active">
                                    Industry Type*
                                  </label>
                                  <Dropdown
                                    className="browser-default"
                                    options={IndustryDataoptions}
                                    onChange={this._onSelectForYears}
                                    value={defaultOptionIndustry}
                                    placeholder="Select"
                                  />
                                  <span
                                    className={
                                      errors.industryTypeId ? "show" : "hide"
                                    }
                                  >
                                    {errors.industryTypeId}
                                  </span>
                                </div>

                                {industryTypeId === 119 ? (
                                  <div className="input-field  col s12">
                                    <TextFieldGroup
                                      field="otherIndustryType"
                                      label="Other Industry*"
                                      value={otherIndustryType}
                                      error={errors.otherIndustryType}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div className="input-field col s12">
                                  <label className="active">
                                    Year your business started*
                                  </label>
                                  <Dropdown
                                    name="cState"
                                    className="browser-default"
                                    options={optionsSince}
                                    onChange={this._cSince1}
                                    value={cDefaultSince3}
                                    placeholder="Select an option*"
                                  />
                                  <span
                                    className={
                                      errors.startingYearError
                                        ? "show invalid"
                                        : "hide"
                                    }
                                  >
                                    {errors.startingYear}
                                  </span>
                                </div>

                                <div className="col s12">
                                  <p>
                                    Did the company file for bankruptcy since
                                    1/1/04?*
                                  </p>
                                  <p className="radio-outer">
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="bankruptcyStatus"
                                        onChange={this.onChange}
                                        type="radio"
                                        checked={bankruptcyStatus === "Y"}
                                        value="Y"
                                      />
                                      <span>Yes</span>
                                    </label>
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="bankruptcyStatus"
                                        onChange={this.onChange}
                                        type="radio"
                                        checked={bankruptcyStatus === "N"}
                                        value="N"
                                      />
                                      <span>No</span>
                                    </label>
                                  </p>
                                </div>

                                <div className="col s12">
                                  <p>Did the company dissolve since 1/1/04?*</p>
                                  <p className="radio-outer">
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="dissolvedStatus"
                                        onChange={this.onChange}
                                        checked={dissolvedStatus === "Y"}
                                        value="Y"
                                        type="radio"
                                      />
                                      <span>Yes</span>
                                    </label>
                                    <label>
                                      <input
                                        className="with-gap"
                                        name="dissolvedStatus"
                                        onChange={this.onChange}
                                        checked={dissolvedStatus === "N"}
                                        value="N"
                                        type="radio"
                                      />
                                      <span>No</span>
                                    </label>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col s12 m12 l6">
                            <div className="profile-wallet">
                              <h5>
                                <span className="right">
                                  <Link to="/transaction">
                                    Transaction History
                                  </Link>
                                </span>
                              </h5>
                              <div className="wallet-list">
                                <h3>Wallet </h3>
                                <h1>
                                  $
                                  {walletBalance
                                    ? walletBalance.toFixed(2)
                                    : 0.0}
                                </h1>
                              </div>
                              {/* <button
                          className='btn waves-effect waves-light primary-btn right'
                          onClick={this.debitAlert}
                        // disabled={walletBalance === 0}
                        >
                          Debit Amount
                        </button> */}
                              {this.state.transcardAccountState == true ? (
                                <div className="link-btn-outer">
                                  <button
                                    className="btn waves-effect waves-light primary-btn right"
                                    type="button"
                                    name="action"
                                    onClick={this.disburseAmountPopup}
                                    disabled={walletBalance <= 0}
                                  >
                                    Disburse Amount
                                  </button>

                                  <button
                                    className="btn waves-effect waves-light primary-btn right"
                                    type="button"
                                    name="addAccount"
                                    onClick={this.addAccountPopup}
                                    // disabled={walletBalance === 0}
                                  >
                                    Add Account
                                  </button>

                                  <button
                                    className="btn waves-effect waves-light primary-btn right"
                                    type="button"
                                    name="action"
                                    onClick={this.viewAccountsPopup}
                                    // disabled={walletBalance === 0}
                                  >
                                    Linked Accounts
                                  </button>
                                </div>
                              ) : (
                                <button
                                  className="btn waves-effect waves-light primary-btn right"
                                  disabled={!this.state.showLinkButton}
                                  type="button"
                                  name="action"
                                  onClick={this.linkAccountPopup}
                                  disabled={walletBalance === 0}
                                >
                                  Link Account
                                </button>
                              )}
                              {this.state.transcardAccountState == false ? (
                                <p className="text-right link-account">
                                  Link your account to get your funds disbursed{" "}
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="row">
                              <h5 className="col s12 blue-heading">
                                Primary Contact Information{" "}
                              </h5>

                              <div className="input-field col s12">
                                <TextFieldGroup
                                  field="firstName"
                                  label="First Name*"
                                  value={firstName}
                                  error={errors.firstName}
                                  onChange={this.onChange}
                                />
                              </div>
                              <div className="input-field col s12">
                                <TextFieldGroup
                                  field="lastName"
                                  label="Last Name*"
                                  value={lastName}
                                  error={errors.lastName}
                                  onChange={this.onChange}
                                />
                              </div>
                              <div className="input-field col s12">
                                <TextFieldGroup
                                  field="companyTitle"
                                  label="Title/Position in company*"
                                  value={companyTitle}
                                  error={errors.companyTitle}
                                  onChange={this.onChange}
                                />
                              </div>
                              <div className="row">
                                <div className="input-field col s4 m5">
                                  <label className="active">Country Code</label>

                                  <Dropdown
                                    name="cState"
                                    className="browser-default"
                                    options={optionsCountry}
                                    onChange={this._countrySelect}
                                    value={cDefaultOptionCountry}
                                    placeholder="Select"
                                  />
                                </div>
                                <div className="input-field col s8 m7">
                                  <MaskInputNumber
                                    field="mobilePhone"
                                    label="Phone Number*"
                                    value={mobilePhone}
                                    error={errors.mobilePhone}
                                    onChange={this.onChange}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="input-field col s4 m5">
                                  <label className="active">Country Code</label>
                                  <Dropdown
                                    name="cState"
                                    className="browser-default"
                                    options={optionsCountry}
                                    onChange={this._countrySelectWork}
                                    value={cDefaultOptionWorkCodeCountry}
                                    placeholder="Select"
                                  />
                                </div>

                                <div className="input-field col s8 m7 padded">
                                  <MaskInputNumber
                                    field="workPhoneNumber"
                                    label="Work Phone Number*"
                                    value={workPhoneNumber}
                                    error={errors.workPhoneNumber}
                                    onChange={this.onChange}
                                  />
                                </div>
                              </div>

                              <div className="input-field col s12 m12 padded">
                                <TextFieldGroup
                                  field="email"
                                  label="Email*"
                                  value={email}
                                  error={errors.email}
                                  checkUserExists={this.verifyEmail}
                                  onChange={this.onChange}
                                />
                              </div>
                            </div>
                            <div className="col s12">
                              <button
                                className="btn waves-effect waves-light primary-btn col s12 update-profile"
                                type="submit"
                                name="action"
                              >
                                Update Profile
                                <i className="material-icons">arrow_forward</i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                      <ChangePassword />
                      <div className="row">
                        <div className="col s12">
                          <div className="row manage-companyinfo">
                            <div className="col s12 m7">
                              <h5 className="tab-heading manage-copmpany">
                                Manage Company Information
                              </h5>
                            </div>
                            <div className="col s12 m5 sub-company">
                              <a
                                className="cr-sgn modal-trigger"
                                onClick={this.openCompanyForm}
                              >
                                Add Individual Business Entity
                              </a>
                              OR
                              <a
                                className=" cr-sgn modal-trigger"
                                onClick={this.openUploadForm}
                              >
                                Bulk Import
                              </a>
                            </div>

                            <div
                              className={
                                recordsCompany.length === 0
                                  ? "hide"
                                  : "show col s12"
                              }
                            >
                              <ReactTable
                                data={recordsCompany}
                                columns={[
                                  {
                                    columns: [
                                      {
                                        Header: "Company Name",
                                        accessor: "companyName",
                                      },
                                      {
                                        Header: "Address",
                                        id: "streeAddress",
                                        accessor: (d) => d.streeAddress,
                                      },
                                      {
                                        Header: "TaxId",
                                        id: "taxId",
                                        accessor: (d) => d.taxId,
                                        filterable: false,
                                      },
                                      {
                                        Header: "Actions",
                                        id: "link",
                                        filterable: false,
                                        accessor: (d) => d,
                                        Cell: (props) => (
                                          <div className="edit-partneraddresslink">
                                            <a
                                              onClick={() =>
                                                this.viewCompanyChild(
                                                  props.value
                                                    .childCompanyProfileId,
                                                  "edit"
                                                )
                                              }
                                            >
                                              <Icon>edit</Icon>{" "}
                                            </a>
                                            <a
                                              onClick={() =>
                                                this.viewCompanyChild(
                                                  props.value
                                                    .childCompanyProfileId,
                                                  "view"
                                                )
                                              }
                                            >
                                              <Icon>preview</Icon>{" "}
                                            </a>
                                            <a
                                              onClick={() =>
                                                this.deleteCompanyChild(
                                                  props.value
                                                    .childCompanyProfileId
                                                )
                                              }
                                            >
                                              <Icon>delete</Icon>{" "}
                                            </a>
                                          </div>
                                        ),
                                      },
                                    ],
                                  },
                                ]}
                                manual
                                defaultPageSize={10}
                                pages={
                                  ChidCompanyData !== undefined
                                    ? Math.ceil(ChidCompanyData.totalCount / 10)
                                    : 1
                                }
                                onFetchData={
                                  this.paginateAllChildCompanyProfile
                                }
                                className="-striped -highlight"
                              />
                            </div>
                            <div
                              className={
                                recordsCompany.length !== 0
                                  ? "hide"
                                  : "show col s12 m12 no-company"
                              }
                            >
                              No Company Information Added
                            </div>
                            <div
                              className={
                                CompanyForm === true
                                  ? "show add-sub-company"
                                  : "hide"
                              }
                            />
                          </div>
                        </div>
                        <div className="col s12">
                          <div className="row">
                            <div className="col s12 business-user-documents ">
                              <div />

                              <div className="col s12  ">
                                <div className=" hdr-bdr " />
                              </div>
                              <h4>User Documents</h4>

                              {/* <div
                      className={
                        privacyPolicyPath === '' ? 'hide' : 'show col s12'
                      }
                    >
                      <div className="col s12">
                        <Tooltip
                          id="tooltip-icon"
                          title="Click here to view document"
                        >
                          <a className="cr-sgn modal-trigger" target="_blank" href={privacyPolicyPath}>
                            {' '}
                            Privacy Policy
                          </a>
                        </Tooltip>
                      </div>
                    </div> */}

                              <div
                                className={
                                  agreementLetterPath === ""
                                    ? "hide"
                                    : "show col s12"
                                }
                              >
                                <div className="col s12">
                                  <Tooltip
                                    id="tooltip-icon"
                                    title="Click here to view document"
                                  >
                                    <a
                                      className="cr-sgn modal-trigger"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={agreementLetterPath}
                                    >
                                      Service Agreement
                                    </a>
                                  </Tooltip>
                                </div>
                              </div>

                              <div
                                className={
                                  letterOfAgencyPath === ""
                                    ? "hide"
                                    : "show col s12"
                                }
                              >
                                <div className="col s12">
                                  <Tooltip
                                    id="tooltip-icon"
                                    title="Click here to view document"
                                  >
                                    <a
                                      className="cr-sgn modal-trigger"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={letterOfAgencyPath}
                                    >
                                      {" "}
                                      Revocable Letter Of Agency
                                    </a>
                                  </Tooltip>
                                </div>
                              </div>
                              <div
                                className={
                                  privacyPolicyPath !== "" &&
                                  agreementLetterPath !== "" &&
                                  letterOfAgencyPath !== ""
                                    ? "hide"
                                    : "show col s12"
                                }
                              >
                                No Document Found
                              </div>

                              <div className="col s12 ">
                                <div className="hdr-bdr " />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col s12">
                          <div className="row terms-profile business-user-documents">
                            <div className="col s12" />
                            <div className="row">
                              <h4>Signature</h4>
                              <CustomSignature
                                defaultValue={signatureDefaultValue}
                                fontFamily={signatureFontFamily}
                                signBack={this.closeModal}
                                finalSubmitData={this.finalSubmit}
                                loader={false}
                                hide={false}
                                openModalSignature={this.state.modalIsOpen}
                              />
                              <div className="signaturte-uploadfile">
                                {" "}
                                {file ? <img src={file} alt="" /> : null}
                              </div>
                              <p>
                                If the authorized signatory for your business
                                has changed, please{" "}
                                <a
                                  href="https://collectively.zendesk.com/hc/en-us/requests/new"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  contact support
                                </a>
                                .{" "}
                              </p>
                            </div>

                            <div className="col s12 ">
                              <div className="divider hdr-bdr " />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row section-content">
                  <div className="dashboard my-profile">
                    <div className="dashboard-tabs">
                      <div className="dashboard-bg settlement-dashboardbg">
                        <BannerHead title="Profile" />
                      </div>

                      <SubuserUpdateBusiness
                        subUserId={localStorage.getItem("userId")}
                        isProfile={true}
                      />
                      <ChangePassword />
                    </div>
                  </div>
                </div>
              )}
            </span>
          </TabPanel>
          <TabPanel>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            {/* Disburse Amount Popup starts here */}

            <Modal
              isOpen={this.state.disburseAmountPopupState}
              onAfterOpen={this.openDisbursePopup}
              onRequestClose={this.closeDisbursePopup}
              style={customStylesDisburse}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="modal-content addvehicle-content disburse-box">
                <div class="pop-header">Transfer Funds</div>
                <div className="found-popup-body">
                  <p className="top-p">
                    Select account to transfer your funds to:
                  </p>
                  <div className="acc-holder-name">
                    {this.state.transcardAccountState
                      ? this.props.receiveGetAddedBankAccountsForUser &&
                        this.props.receiveGetAddedBankAccountsForUser.data &&
                        this.props.receiveGetAddedBankAccountsForUser.data
                          .code == "200" &&
                        this.props.receiveGetAddedBankAccountsForUser.data
                          .result &&
                        this.props.receiveGetAddedBankAccountsForUser.data.result.map(
                          (bankAcc) => bankAcc.accountDisplayName
                        )
                      : this.props.receiveGetAddedCardsForUser &&
                        this.props.receiveGetAddedCardsForUser.code == "200" &&
                        this.props.receiveGetAddedCardsForUser.result.map(
                          (card) => card.cardNickName
                        )}
                  </div>

                  <div className="funds-list-outer">
                    <p className="w-acc-link" />
                    <p className="p-sub">
                      This could take up to 2 business days to transfer
                    </p>
                    <div className="fund-list">
                      <div className="fund-list-count">
                        <p>Settlement Amount:</p>
                        <span className="fund-cost">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.totalAmount.toFixed(
                              2
                            )}
                        </span>
                      </div>
                      <div className="fund-list-count">
                        {this.state.transcardAccountState == true ? (
                          <p>ACH transfer fee (3%):</p>
                        ) : (
                          <p>Instant fee (5%):</p>
                        )}

                        <span className="fund-cost">
                          ($
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.transferFee.toFixed(
                              2
                            )}
                          )
                        </span>
                      </div>
                      <div className="fund-list-count">
                        <p>Final Transfer Amount: </p>
                        <span className="fund-cost-total">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.finalAmountToBeCollected.toFixed(
                              2
                            )}
                        </span>
                      </div>
                    </div>
                    <p className="btm-p">
                      After clicking Transfer Funds, this process is final and
                      cannot be undone.
                    </p>
                    <div className="popup-footer">
                      <button
                        className="btn btn-footer-1"
                        type="submit"
                        name="action"
                        onClick={this.closeDisbursePopup}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-footer-2"
                        type="submit"
                        name="action"
                        onClick={this.disburseAmount}
                      >
                        Transfer Funds
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="col s12">
              <div className="grey-box">
                <div className="grey-inner">
                  <p> Your wallet balance of ${this.state.walletBalance && this.state.walletBalance.toFixed(2)} will be transferred to your bank acc, would you like to proceed ?</p>
                  <button
                    onClick={this.disburseAmount}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Proceed
                    <i className="material-icons">arrow_forward</i>
                  </button>

                  <button
                    onClick={this.closeDisbursePopup}
                    style={{ marginLeft: "5px" }}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Cancel
                    <i className="material-icons">arrow_forward</i>
                  </button>
                  
                </div>
                <Link to={'/profile'} onClick={this.viewAccountsPopup}  className="">Change Account</Link>
              </div>
            </div> */}
              </div>
            </Modal>

            {/* Disburse amount popup ends here */}
            {/* Link Account Popup  Starts Here --------Main popup */}

            <Modal
              isOpen={this.state.linkAccountStep1}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Link Account</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.value}>
                    <TabPanel1 value="1">
                      <LinkAccountStep2
                        onChangeStep2={this.onChangeStep2}
                        onChangeStep2Select={this.onChangeStep2Select}
                        handlePopupSubmit={this.handlePopupSubmit}
                        routingNumber={this.state.routingNumber}
                        accountNumber={this.state.accountNumber}
                        accountType={this.state.accountType}
                        accountHolderName={this.state.accountHolderName}
                        displayName={this.state.displayName}
                        accountHolderNameError={
                          this.state.accountHolderNameError
                        }
                        displayNameError={this.state.displayNameError}
                        accountNumberError={this.state.accountNumberError}
                        routingNumberError={this.state.routingNumberError}
                        accountTypeError={this.state.accountTypeError}
                        addMultipleAccountState={
                          this.state.addMultipleAccountState
                        }
                        onClick={this.handleCancel}
                      />
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          this.state.createAccEnable == false ? true : false
                        }
                        className={
                          this.state.createAccEnable == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handlePopupSubmit}
                        name="back"
                      >
                        Create Account
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/* Link Account Popup  Ends Here*/}
            {/* Disburse Amount Popup starts here */}

            <Modal
              isOpen={this.state.disburseCardPopupState}
              onAfterOpen={this.openDisbursePopup}
              onRequestClose={this.closeDisbursePopup}
              style={customStylesDisburse}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="modal-content addvehicle-content disburse-box">
                <div class="pop-header">Transfer Funds</div>
                <div className="found-popup-body">
                  <p className="top-p">
                    Select account to transfer your funds to:
                  </p>
                  <div className="acc-holder-name">
                    {this.props.receiveGetAddedCardsForUser &&
                      this.props.receiveGetAddedCardsForUser.code == "200" &&
                      this.props.receiveGetAddedCardsForUser.result.map(
                        (card) => card.cardNickName
                      )}
                  </div>

                  <div className="funds-list-outer">
                    <p className="w-acc-link" />
                    <p className="p-sub">
                      This could take up to 2 business days to transfer
                    </p>
                    <div className="fund-list">
                      <div className="fund-list-count">
                        <p>Settlement Amount:</p>
                        <span className="fund-cost">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.totalAmount.toFixed(
                              2
                            )}
                        </span>
                      </div>
                      <div className="fund-list-count">
                        <p>ACH transfer fee (3%):</p>
                        <span className="fund-cost">
                          ($
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.transferFee.toFixed(
                              2
                            )}
                          )
                        </span>
                      </div>
                      <div className="fund-list-count">
                        <p>Final Transfer Amount: </p>
                        <span className="fund-cost-total">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.finalAmountToBeCollected.toFixed(
                              2
                            )}
                        </span>
                      </div>
                    </div>
                    <p className="btm-p">
                      After clicking Transfer Funds, this process is final and
                      cannot be undone.
                    </p>
                    <div className="popup-footer">
                      <button
                        className="btn btn-footer-1"
                        type="submit"
                        name="action"
                        onClick={this.closeDisbursePopup}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-footer-2"
                        type="submit"
                        name="action"
                        onClick={this.disburseAmount}
                      >
                        Transfer Funds
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>

            {/* Disburse amount popup ends here */}

            {/* Save Card details Popup  Starts Here*/}

            <Modal
              isOpen={this.state.instantTransferPopupState}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeInstantPopup}
              style={customStylesCardDetails}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Save Card Details</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs card-change">
                <div className="col s12">
                  <CardInputField
                    divClassName="input-field col s4"
                    field="cardFirstName"
                    label="First Name *"
                    // placeholder="Name on Card"
                    value={cardFirstName}
                    error={cardErrors.cardFirstName}
                    onChange={this.onChangeCarad}
                  />
                  <CardInputField
                    divClassName="input-field col s4"
                    field="cardLastName"
                    label="Last Name  *"
                    // placeholder="Name on Card"
                    value={cardLastName}
                    error={cardErrors.cardLastName}
                    onChange={this.onChangeCarad}
                  />
                  <CardInputField
                    divClassName="input-field col s4"
                    field="cardNickName"
                    label="Nick Name *"
                    // placeholder="Name on Card"
                    value={cardNickName}
                    error={cardErrors.cardNickName}
                    onChange={this.onChangeCarad}
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s12 pb-20 mb-0"
                    field="cardNumber"
                    label="Card Number *"
                    placeholder="Card Number"
                    value={cardNumber}
                    error={cardErrors.cardNumber}
                    onChange={this.onChangeCarad}
                    mask="9999 9999 9999 9999"
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s4"
                    field="cardMonth"
                    label="Month *"
                    placeholder="Month"
                    value={cardMonth}
                    error={cardErrors.cardMonth}
                    onChange={this.onChangeCarad}
                    mask="99"
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s4 checkoutyear-input mb-0"
                    field="cardYear"
                    label="Year *"
                    placeholder="Year"
                    value={cardYear}
                    error={cardErrors.cardYear}
                    onChange={this.onChangeCarad}
                    mask="99"
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s4"
                    field="cardCvv"
                    label="CVV *"
                    placeholder="CVV"
                    value={cardCvv}
                    error={cardErrors.cardCvv}
                    onChange={this.onChangeCarad}
                    mask="9999"
                  />
                  <div className="w-dflex col s12">
                    <button
                      onClick={this.handleSaveCard}
                      disabled={
                        this.state.cardErrorsState.cardNickName == "" &&
                        this.state.cardErrorsState.cardNickNameError == false &&
                        this.state.cardErrorsState.cardLastName == "" &&
                        this.state.cardErrorsState.cardLastNameError == false &&
                        this.state.cardErrorsState.cardFirstName == "" &&
                        this.state.cardErrorsState.cardFirstNameError ==
                          false &&
                        this.state.cardErrorsState.cardFirstName == "" &&
                        this.state.cardErrorsState.cardFirstNameError ==
                          false &&
                        this.state.cardErrorsState.cardCvv == "" &&
                        this.state.cardErrorsState.cardCvvError == "" &&
                        this.state.cardErrorsState.cardMonth == false &&
                        this.state.cardErrorsState.cardMonthError == "" &&
                        this.state.cardErrorsState.cardNumber == false &&
                        this.state.cardErrorsState.cardNumberError == "" &&
                        this.state.cardErrorsState.cardYear == false &&
                        this.state.cardErrorsState.cardYearError == ""
                          ? false
                          : true
                      }
                      className="btn btn-primary"
                      type="submit"
                      name="action"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </Modal>

            {/* Save Card details  Ends Here*/}

            {/* Link New Account Popup  Starts Here*/}

            <Modal
              isOpen={this.state.bankAccountConfirmationPopup}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStylesConfirmationPopup}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Please Select Bank Account</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12 pt-5">
                {this.state.noAccountLinked == false
                    ? "You can select from your previously linked Bank accounts:"
                    : "Please add new account:-"}
                  <div className=" full-field padding-field">
                    <p className="radio-outer confirm-radio-popup">
                      {this.props.receiveGetAllBankAccountsForUser &&
                        this.props.receiveGetAllBankAccountsForUser.data &&
                        this.props.receiveGetAllBankAccountsForUser.data
                          .result &&
                        this.props.receiveGetAllBankAccountsForUser.data.result.map(
                          (displayName) => (
                            <label>
                              <input
                                className="with-gap"
                                name="accountName"
                                onChange={this.accountNameChange}
                                checked={
                                 
                                  this.state.radioAccountValue == displayName.id 
                                }
                                value={displayName.id}
                                type="checkbox"
                                onClick = {this.dualChange}
                              />
                              <span>{displayName.accountDisplayName}</span>
                            </label>
                          )
                        )}
                    </p>
                  </div>
                  {/* <button
                    // disabled={!isEmpty(errors)}
                    className={
                      !isEmpty(errors)
                        ? " waves-effect waves-light ltgrey-btn btn-tab"
                        : " waves-effect waves-light pink-btn btn-tab"
                    }
                    type="submit"
                    onClick={this.handleCancel}
                    name="cancel"
                  >
                    Cancel
                  </button> */}
                  {this.state.noAccountLinked == false ? (
                    <button
                      disabled={
                        !this.state.radioAddedAccountChecked === true
                          ? true
                          : false
                      }
                      className={"waves-effect waves-light pink-btn btn-tab"}
                      type="submit"
                      onClick={this.handleAlreadyAddedAccount}
                      name="back"
                    >
                      Continue
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    disabled={
                      this.state.radioAddedAccountChecked === true
                        ? true
                        : false
                    }
                    className={"waves-effect waves-light pink-btn btn-tab"}
                    type="submit"
                    onClick={this.handleAddNewAccount}
                    name="back"
                    value="addNewAccount"
                  >
                    Add New Account
                  </button>
                </div>
              </div>
            </Modal>

            {/* Link New Account Popup  Ends Here*/}

            {/* Link New Card Popup  Starts Here*/}

            <Modal
              isOpen={this.state.bankCardConfirmationPopup}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStylesConfirmationPopup}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Please Select Card</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12 pt-5">
                  {this.state.noCardLinked == false
                    ? "You can select from your previously linked cards:"
                    : "Please add new card:-"}
                  <div className=" full-field padding-field">
                    <p className="radio-outer confirm-radio-popup">
                      {this.props.receiveGetAllAddedCardsForUser &&
                        this.props.receiveGetAllAddedCardsForUser.data &&
                        this.props.receiveGetAllAddedCardsForUser.data.result &&
                        this.props.receiveGetAllAddedCardsForUser.data.result.map(
                          (displayName) => (
                            <label>
                              <input
                                className="with-gap"
                                name="accountName"
                                onChange={this.cardNameChange}
                                checked={
                                  this.state.radioCardValue == displayName.id
                                }
                                value={displayName.id}
                                type="checkbox"
                              />
                              <span>{displayName.cardNickName}</span>
                            </label>
                          )
                        )}
                    </p>
                  </div>
                  {this.state.noCardLinked == false ? (
                    <button
                      disabled={
                        !this.state.radioAddedCardChecked === true
                          ? true
                          : false
                      }
                      className={"waves-effect waves-light pink-btn btn-tab"}
                      type="submit"
                      onClick={this.handleAlreadyAddedCard}
                      name="back"
                    >
                      Continue
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    disabled={
                      this.state.radioAddedCardChecked === true ? true : false
                    }
                    className={"waves-effect waves-light pink-btn btn-tab"}
                    type="submit"
                    onClick={this.handleAddNewCard}
                    name="back"
                    value="addNewCard"
                  >
                    Add New Card
                  </button>
                </div>
              </div>
            </Modal>

            {/* Link New Card Popup  Ends Here*/}

            {/* Account Type Popup starts here */}

            <Modal
              isOpen={this.state.accountTypePopupState}
              onAfterOpen={this.openAccountTypePopup}
              onRequestClose={this.closeAccountTypePopup}
              style={customStylesTransferType}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Transfer Type</div>
              <div className="modal-content addvehicle-content disburse-box">
                <div className="radio radio-new">
                  <form
                    className="p-30 p-form"
                    onSubmit={this.handleSubmitTransferType}
                  >
                    <label className="mb-3">
                      <input
                        type="radio"
                        name="radio"
                        value="ach"
                        onChange={this.onTransferCheck}
                        checked={this.state.achState}
                      />
                      <span>ACH</span>
                    </label>
                    <label className="mb-3">
                      <input
                        type="radio"
                        name="radio"
                        onChange={this.onTransferCheck}
                        value="instant"
                        checked={this.state.instantTransferState}
                      />
                      <span>Instant Transfer</span>
                    </label>
                    {this.state.instantTransferState == true ||
                    this.state.achState == true ? (
                      <p>
                        {this.state.achState == true
                          ? "You will be charged 3% of the amount as transaction fee"
                          : "You will be charged 5% of the amount as transaction fee"}
                      </p>
                    ) : (
                      ""
                    )}

                    <div className="w-dflex mt-3">
                      <button
                        disabled={
                          this.state.instantTransferState === false &&
                          this.state.achState === false
                        }
                        type="submit"
                        name="next"
                        className="btn btn-primary"
                      >
                        Next
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Modal>

            {/* Account Type popup ends here */}

            {/*Card Address Popup  Starts Here*/}

            <Modal
              isOpen={this.state.linkCardAccountStep1}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Card Address</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.cardValue}>
                    <TabPanel1 value="1">
                      <LinkCardAccountAddress
                        onChangeCardAddress={this.onChangeCardAddress}
                        onChangeCardAddressSelect={
                          this.onChangeCardAddressSelect
                        }
                        handlePopupSubmit={this.handlePopupSubmit}
                        address1CardPopup={this.state.address1CardPopup}
                        address2CardPopup={this.state.address2CardPopup}
                        cityCardPopup={this.state.cityCardPopup}
                        zipCardPopup={this.state.zipCardPopup}
                        address1CardPopupError={
                          this.state.address1CardPopupError
                        }
                        address2CardPopupError={
                          this.state.address2CardPopupError
                        }
                        stateCardPopupName={this.state.stateCardPopupName}
                        stateCardPopup={this.state.stateCardPopup}
                        cityCardPopupError={this.state.cityCardPopupError}
                        zipCardPopupError={this.state.zipCardPopupError}
                        addMultipleAccountState={
                          this.state.addMultipleAccountState
                        }
                        onClick={this.handleCancel}
                      />
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          this.state.addressCardNextButton == false
                            ? true
                            : false
                        }
                        className={
                          this.state.addressCardNextButton == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleSubmitNextCardAddress}
                        name="next"
                      >
                        Next
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/*Card Address Popup  Ends Here*/}

                        {/* Add Card Popup  Starts Here*/}
                        <Modal
              isOpen={this.state.nextCardButtonStepActive}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Link Card</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.cardValue}>
                    <TabPanel1 value="3">
                      <div className="row consumer-tab-info ibmfont signup-new-tabs card-change">
                        <div className="col s12">
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardFirstName"
                            label="First Name *"
                            // placeholder="Name on Card"
                            value={cardFirstName}
                            error={cardErrors.cardFirstName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardLastName"
                            label="Last Name  *"
                            // placeholder="Name on Card"
                            value={cardLastName}
                            error={cardErrors.cardLastName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardNickName"
                            label="Nick Name *"
                            // placeholder="Name on Card"
                            value={cardNickName}
                            error={cardErrors.cardNickName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s8"
                            field="cardNumber"
                            label="Card Number *"
                            placeholder="Card Number"
                            value={cardNumber}
                            error={cardErrors.cardNumber}
                            onChange={this.onChangeCarad}
                            mask="9999 9999 9999 9999"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4"
                            field="cardCvv"
                            label="CVV *"
                            placeholder="CVV"
                            value={cardCvv}
                            error={cardErrors.cardCvv}
                            onChange={this.onChangeCarad}
                            mask="9999"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4"
                            field="cardMonth"
                            label="Month *"
                            placeholder="Month"
                            value={cardMonth}
                            error={cardErrors.cardMonth}
                            onChange={this.onChangeCarad}
                            mask="99"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4 checkoutyear-input mb-0"
                            field="cardYear"
                            label="Year *"
                            placeholder="Year"
                            value={cardYear}
                            error={cardErrors.cardYear}
                            onChange={this.onChangeCarad}
                            mask="99"
                          />
                          <div className="w-dflex col s12"></div>
                        </div>
                      </div>
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        // disabled={
                        //   this.state.createAccEnable == false ? true : false
                        // }
                        disabled={
                          this.state.cardErrorsState.cardNickName == "" &&
                          this.state.cardErrorsState.cardNickNameError ==
                            false &&
                          this.state.cardErrorsState.cardLastName == "" &&
                          this.state.cardErrorsState.cardLastNameError ==
                            false &&
                          this.state.cardErrorsState.cardFirstName == "" &&
                          this.state.cardErrorsState.cardFirstNameError ==
                            false &&
                          this.state.cardErrorsState.cardFirstName == "" &&
                          this.state.cardErrorsState.cardFirstNameError ==
                            false &&
                          this.state.cardErrorsState.cardCvv == "" &&
                          this.state.cardErrorsState.cardCvvError == "" &&
                          this.state.cardErrorsState.cardMonth == false &&
                          this.state.cardErrorsState.cardMonthError == "" &&
                          this.state.cardErrorsState.cardNumber == false &&
                          this.state.cardErrorsState.cardNumberError == "" &&
                          this.state.cardErrorsState.cardYear == false &&
                          this.state.cardErrorsState.cardYearError == ""
                            ? false
                            : true
                        }
                        className={
                          this.state.createAccEnable == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={
                          this.state.cardAlreadyLinked == false
                            ? this.handleCardPopupSubmit
                            : this.handleCardPopupAlreadyLinkedSubmit
                        }
                        name="back"
                      >
                        Create Account
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/* Add Card Popup  Ends Here*/}

            {/* Add Card Popup  Starts Here*/}
            <Modal
              isOpen={this.state.cardButtonStepActive}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Link Card</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={"3"}>
                    <TabPanel1 value="3">
                      <div className="row consumer-tab-info ibmfont signup-new-tabs card-change">
                        <div className="col s12">
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardFirstName"
                            label="First Name *"
                            // placeholder="Name on Card"
                            value={cardFirstName}
                            error={cardErrors.cardFirstName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardLastName"
                            label="Last Name  *"
                            // placeholder="Name on Card"
                            value={cardLastName}
                            error={cardErrors.cardLastName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardNickName"
                            label="Nick Name *"
                            // placeholder="Name on Card"
                            value={cardNickName}
                            error={cardErrors.cardNickName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s8"
                            field="cardNumber"
                            label="Card Number *"
                            placeholder="Card Number"
                            value={cardNumber}
                            error={cardErrors.cardNumber}
                            onChange={this.onChangeCarad}
                            mask="9999 9999 9999 9999"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4"
                            field="cardCvv"
                            label="CVV *"
                            placeholder="CVV"
                            value={cardCvv}
                            error={cardErrors.cardCvv}
                            onChange={this.onChangeCarad}
                            mask="9999"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4"
                            field="cardMonth"
                            label="Month *"
                            placeholder="Month"
                            value={cardMonth}
                            error={cardErrors.cardMonth}
                            onChange={this.onChangeCarad}
                            mask="99"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4 checkoutyear-input mb-0"
                            field="cardYear"
                            label="Year *"
                            placeholder="Year"
                            value={cardYear}
                            error={cardErrors.cardYear}
                            onChange={this.onChangeCarad}
                            mask="99"
                          />
                          <div className="w-dflex col s12"></div>
                        </div>
                      </div>
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        // disabled={
                        //   this.state.createAccEnable == false ? true : false
                        // }
                        disabled={
                          this.state.cardErrorsState.cardNickName == "" &&
                          this.state.cardErrorsState.cardNickNameError ==
                            false &&
                          this.state.cardErrorsState.cardLastName == "" &&
                          this.state.cardErrorsState.cardLastNameError ==
                            false &&
                          this.state.cardErrorsState.cardFirstName == "" &&
                          this.state.cardErrorsState.cardFirstNameError ==
                            false &&
                          this.state.cardErrorsState.cardFirstName == "" &&
                          this.state.cardErrorsState.cardFirstNameError ==
                            false &&
                          this.state.cardErrorsState.cardCvv == "" &&
                          this.state.cardErrorsState.cardCvvError == "" &&
                          this.state.cardErrorsState.cardMonth == false &&
                          this.state.cardErrorsState.cardMonthError == "" &&
                          this.state.cardErrorsState.cardNumber == false &&
                          this.state.cardErrorsState.cardNumberError == "" &&
                          this.state.cardErrorsState.cardYear == false &&
                          this.state.cardErrorsState.cardYearError == ""
                            ? false
                            : true
                        }
                        className={
                          this.state.createAccEnable == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={
                          this.state.cardAlreadyLinked == false
                            ? this.handleCardPopupSubmit
                            : this.handleCardPopupAlreadyLinkedSubmit
                        }
                        name="back"
                      >
                        Create Account
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/* Add Card Popup  Ends Here*/}

            {/* Edit Accout Popup Starts Here */}

            <Modal
              isOpen={this.state.openEditModel}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customEditStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div class="pop-header">Edit Account</div>
              <div className="found-popup-body">
                <p className="edit-popup-pb">
                  {this.props.receiveGetAddedBankAccountsForUser &&
                  this.props.receiveGetAddedBankAccountsForUser.code == "200" &&
                  this.props.receiveGetAddedBankAccountsForUser.result[0]
                    .accountType == "1"
                    ? "Checking Account"
                    : "Savings Account"}{" "}
                </p>
                <span className="nick-name-l">Account Nickname</span>
                <div className="e-holder-name">
                  {this.props.receiveGetAddedBankAccountsForUser &&
                    this.props.receiveGetAddedBankAccountsForUser.data &&
                    this.props.receiveGetAddedBankAccountsForUser.data.code ==
                      "200" &&
                    this.props.receiveGetAddedBankAccountsForUser.data.result.map(
                      (bankAcc) => (
                        <input
                          name="bankName"
                          value={this.state.bankName}
                          onChange={this.onChangeEditAccount}
                        />
                      )
                    )}
                </div>
                {this.state.errorbankName == true ? (
                  <div
                    className="error-class"
                    style={{ fontSize: 12, color: "red" }}
                  >
                    This field can't be blank.
                  </div>
                ) : (
                  ""
                )}
                <div className="d-option pb-0">
                  {this.state.showDeleteConfirmation == false ? (
                    <div
                      onClick={this.handleShowDeleteConfirmation}
                      style={{
                        cursor: "pointer",
                        color: "#1f202e",
                        opacity: ".3",
                        textDecoration: "underline",
                      }}
                    >
                      Delete This Account
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {this.state.showDeleteConfirmation ? (
                  <div className="delet-option-btn">
                    <p>Are you sure you want to delete this account?</p>
                    <div className="btn-outer-delet">
                      <button
                        className="btn btn-dlt"
                        onClick={this.removeBankAccount}
                        value={
                          this.props.receiveGetAddedBankAccountsForUser &&
                          this.props.receiveGetAddedBankAccountsForUser.data &&
                          this.props.receiveGetAddedBankAccountsForUser.data
                            .result &&
                          this.props.receiveGetAddedBankAccountsForUser.data
                            .result[0].id
                        }
                        type="submit"
                        name="action"
                      >
                        Delete Account
                      </button>
                      <button
                        onClick={this.handleShowDeleteConfirmation}
                        className="btn btn-clc"
                        type="submit"
                        name="action"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div class="popup-footer edit-poup-footer">
                  <button
                    class="btn btn-footer-1"
                    type="submit"
                    onClick={this.cancelEditModel}
                    name="action"
                  >
                    Cancel
                  </button>
                  <button
                    class="btn btn-footer-2"
                    type="submit"
                    disabled={this.state.updateBankButton == false}
                    onClick={this.changeBankNickName}
                    name="action"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </Modal>

            {/* Edit Account Popup Ends Here */}

            {/* Edit Card Popup Starts Here */}

            <Modal
              isOpen={this.state.openEditCardModel}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customEditStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Edit Card</div>
              <div className="found-popup-body">
                <p className="edit-popup-pb">
                  {this.props.receiveGetAddedCardsForUser &&
                  this.props.receiveGetAddedCardsForUser.code == "200"
                    ? "Card Details"
                    : "Card Details"}{" "}
                </p>
                <span className="nick-name-l">Card Nickname</span>
                <div className="e-holder-name">
                  {this.props.receiveGetAddedCardsForUser &&
                    this.props.receiveGetAddedCardsForUser.code == "200" &&
                    this.props.receiveGetAddedCardsForUser.result.map(
                      (card) => (
                        <input
                          name="bankName"
                          value={this.state.cardNickName}
                          onChange={this.onChangeEditCard}
                        />
                      )
                    )}
                </div>
                {this.state.errorCardName == true ? (
                  <div
                    className="error-class"
                    style={{ fontSize: 12, color: "red" }}
                  >
                    This field can't be blank.
                  </div>
                ) : (
                  ""
                )}
                <div className="d-option">
                  {this.state.showDeleteConfirmation == false ? (
                    <div
                      onClick={this.handleShowDeleteConfirmation}
                      style={{
                        cursor: "pointer",
                        color: "#1f202e",
                        opacity: ".3",
                        textDecoration: "underline",
                      }}
                    >
                      Delete This Account
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {this.state.showDeleteConfirmation ? (
                  <div className="delet-option-btn">
                    <p>Are you sure you want to delete this card?</p>
                    <div className="btn-outer-delet">
                      <button
                        className="btn btn-dlt"
                        onClick={this.removeBankCard}
                        value={
                          this.props.receiveGetAddedCardsForUser &&
                          this.props.receiveGetAddedCardsForUser.result &&
                          this.props.receiveGetAddedCardsForUser.result[0].id
                        }
                        type="submit"
                        name="action"
                      >
                        Delete card
                      </button>
                      <button
                        onClick={this.handleShowDeleteConfirmation}
                        className="btn btn-clc"
                        type="submit"
                        name="action"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="popup-footer edit-poup-footer">
                  <button
                    className="btn btn-footer-1"
                    type="submit"
                    onClick={this.cancelEditModel}
                    name="action"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-footer-2"
                    type="submit"
                    disabled={this.state.updateCardButton == false}
                    onClick={this.changeCardNickName}
                    name="action"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </Modal>

            {/* Edit Card Popup Ends Here */}
            <ToastsContainer
              store={ToastsStore}
              className="toast-error-msg"
              position={ToastsContainerPosition.TOP_CENTER}
              lightBackground
            />
            {loader1}
            <div
              className="wallet-1 wallet-1-top {
    display: flex;
}"
            >
              <div className="top-left-head">
                <h3 className="w-h3">Available Funds</h3>
                <div className="w-dflex">
                  <div className="w-link-acc">
                    <div className="w-link-count">
                      ${walletBalance ? walletBalance.toFixed(2) : 0.0}
                    </div>
                    <div className="w-lock">
                      <img
                        src={
                          this.state.transcardAccountState == false &&
                          this.state.transcardCardState == false
                            ? lockImage
                            : ""
                        }
                      ></img>
                    </div>
                    <button
                      className={
                        this.state.transcardAccountState == false
                          ? "btn btn-primary link-transfer"
                          : "btn btn-primary link-transfer"
                      }
                      // onClick={this.state.transcardAccountState == false ? this.linkAccountPopup : this.disburseAmountPopup}
                      value="addNewLinkAccount"
                      onClick={
                        (this.state.transcardAccountState == true &&
                          this.state.hasAnyActiveAccount == true &&
                          this.state.noAccountLinked == false) ||
                        (this.state.transcardCardState == true &&
                          this.state.hasAnyActiveCard == true &&
                          this.state.noCardLinked == false)
                          ? this.disburseAmountPopup
                          : this.state.AddNewBankAccountState == true &&
                            this.state.noAccountLinked == false &&
                            this.state.userHasNoAccounts == false
                          ? this.accountTypePopup
                          : this.accountTypePopup
                      }
                      disabled={walletBalance === 0}
                      name={
                        this.state.transcardAccountState == true
                          ? "transferFunds"
                          : "linkToTransfer"
                      }
                    >
                      {(this.state.transcardAccountState == true &&
                        this.state.hasAnyActiveAccount == true &&
                        this.state.noAccountLinked == false) ||
                      (this.state.transcardCardState == true &&
                        this.state.hasAnyActiveCard == true &&
                        this.state.noCardLinked == false)
                        ? "Transfer Funds"
                        : (this.state.AddNewBankAccountState == true &&
                            this.state.noAccountLinked == false &&
                            this.state.userHasNoAccounts == false) ||
                          (this.state.AddNewCardState == true &&
                            this.state.noCardLinked == false &&
                            this.state.userHasNoCards == false)
                        ? "Add Payment Method"
                        : "Link Account to Transfer Funds"}
                    </button>
                  </div>
                  {walletBalance != 0 &&
                  this.state.userHasNoCards == true &&
                  this.state.userHasNoAccounts == true ? (
                    <div className="w-lable">
                      To transfer funds, we first need to securely link to your
                      account.<span className="qus-icon">?</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.state.transcardAccountState == true ? (
                <div className="top-right-head">
                  {this.props.receiveGetAddedBankAccountsForUser &&
                  this.props.receiveGetAddedBankAccountsForUser.data &&
                  this.props.receiveGetAddedBankAccountsForUser.data.code ==
                    "200" ? (
                    <div className="w-link-btn bdr-btm-1">
                      {" "}
                      <h3>Linked Account</h3>{" "}
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <button className="btn btn-link-acc">
                         Add Another Account
                         </button> */}

                  {this.props.receiveGetAddedBankAccountsForUser &&
                    this.props.receiveGetAddedBankAccountsForUser.data.code ==
                      "200" &&
                    this.props.receiveGetAddedBankAccountsForUser.data.result.map(
                      (bankAcc) => (
                        <div className="w-link-btn">
                          <p>{bankAcc.accountDisplayName}</p>
                          <button
                            onClick={this.editAccount}
                            className="edit-btn"
                          >
                            Edit
                          </button>
                        </div>
                      )
                    )}
                </div>
              ) : (
                ""
              )}
              {/* Linked Account for cards */}

              {this.state.transcardCardState == true ? (
                <div className="top-right-head">
                  {this.props.receiveGetAddedCardsForUser &&
                  this.props.receiveGetAddedCardsForUser.code == "200" ? (
                    <div className="w-link-btn bdr-btm-1">
                      {" "}
                      <h3>Linked Card</h3>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <button className="btn btn-link-acc">
                         Add Another Account
                         </button> */}

                  {this.props.receiveGetAddedCardsForUser &&
                    this.props.receiveGetAddedCardsForUser.code == "200" &&
                    this.props.receiveGetAddedCardsForUser.result.map(
                      (card) => (
                        <div className="w-link-btn">
                          <p>{card.cardNickName}</p>
                          <button onClick={this.editCard} className="edit-btn">
                            Edit
                          </button>
                        </div>
                      )
                    )}
                </div>
              ) : (
                ""
              )}
            </div>
            {/* {walletBalance !=0 ?   */}
            <div>
              {this.state.transcardAccountState == false &&
              this.state.transcardCardState == false &&
              walletBalance == 0 ? (
                <div className="You-can-link-your-ac">
                  You can link your account once funds have been collected in a
                  settlement.
                </div>
              ) : (
                ""
              )}
              {walletBalance != 0 ? (
                <div className="w-table-outer">
                  <h3 className="w-h3">Collected Settlements</h3>
                  <Table className="table-layout">
                    <TableHead>
                      <TableRow>
                        <TableCell className="w-table-name">
                          Settlement Name
                        </TableCell>
                        <TableCell className="w-table-gross">
                          Gross Distribution
                        </TableCell>
                        <TableCell className="w-table-fee">
                          Collectively Fee
                        </TableCell>
                        <TableCell className="w-table-distri">
                          Net Distribution
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {this.props.receiveGetCollectedSettlementsHistoryForUser
                      .data &&
                      this.props.receiveGetCollectedSettlementsHistoryForUser
                        .data.code == "200" &&
                      this.props.receiveGetCollectedSettlementsHistoryForUser.data.result.records.map(
                        (historySet) => (
                          <TableBody>
                            <TableRow>
                              <TableCell className="table-name">
                                <i className="material-icons t-icon">
                                  play_arrow
                                </i>{" "}
                                {historySet.settlementShortName}
                              </TableCell>
                              <TableCell className="w-text-right">
                                {historySet.priceBreakupDto.totalAmount}
                              </TableCell>
                              <TableCell className="w-text-right">
                                <span className="w-red">
                                  ($
                                  {historySet.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                                    2
                                  )}
                                  ){" "}
                                </span>
                              </TableCell>
                              <TableCell className="w-text-right">
                                $
                                {historySet.priceBreakupDto.userAmount.toFixed(
                                  2
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )
                      )}
                  </Table>
                </div>
              ) : (
                <div>
                  <h3 className="w-h3">Collected Settlements</h3>
                  <p className="No-Payments-Yet">No Settlements Available</p>
                </div>
              )}
              {this.props.receiveGetUserTransactionsHistory &&
              this.props.receiveGetUserTransactionsHistory.data &&
              this.props.receiveGetUserTransactionsHistory.data.code &&
              this.props.receiveGetUserTransactionsHistory.data.code != 404 ? (
                <div className="w-pay-history w-table-outer">
                  <h3 className="w-h3">Payment History</h3>

                  <div className="w-history-table">
                    <Table className="table-layout">
                      <TableHead>
                        <TableRow>
                          <TableCell className="w-table-set">
                            Settlement
                          </TableCell>
                          <TableCell className="w-table-gamount">
                            Gross Amount
                          </TableCell>
                          <TableCell className="w-table-gross">
                            Colletively Fee
                          </TableCell>
                          <TableCell className="w-table-gross">
                            Transfer Fee
                          </TableCell>
                          <TableCell className="w-table-type">Type</TableCell>
                          <TableCell className="w-table-namount">
                            Net Amount
                          </TableCell>
                          <TableCell className="w-table-status">
                            Status
                          </TableCell>
                          <TableCell className="w-table-date">Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className="row-coll">
                          <TableCell className="table-name d-col-flex">
                            <span className="t-btn-coll" onClick={this.toggleHandlerOne} style={{cursor: "pointer"}}> {this.state.tableState ? "+" : "-" } </span>{" "}
                            <span className="b-text"> 2021 </span>
                          </TableCell>

                          <TableCell colSpan={7} className="w-text-right">
                            Export ,<span className="b-text"> 
                            {/* <button style={{outline: "none",border:"none",background:"none"}} onClick={()=>this.exportPDF(this.props.receiveGetUserTransactionsHistory.data)}>PDF</button> */}
                            <DownloadPdfFile datas={this.props.receiveGetUserTransactionsHistory.data}/>
                            / <CSVLink {...csvReport}>CSV</CSVLink> </span>
                          </TableCell>
                        </TableRow>
                        
                        {console.log("yes1",this.props.receiveGetUserTransactionsHistory.data)}
                        {this.props.receiveGetUserTransactionsHistory.data &&
                          this.props.receiveGetUserTransactionsHistory.data
                            .code == "200" &&
                          this.props.receiveGetUserTransactionsHistory.data.result.records.map(
                            (transactionHistory) => {
                              return (
                              <TableRow>
                                {this.state.tableState ? null :
                                <>
                                <TableCell className="table-name">
                                  <i className="material-icons t-icon">
                                    play_arrow
                                  </i>{" "}
                                  {transactionHistory.settlementShortName}
                                </TableCell>
                                <TableCell className="">
                                  $
                                  {transactionHistory.priceBreakupDto.totalAmount.toFixed(
                                    2
                                  )}
                                </TableCell>
                                <TableCell className="w-text-right">
                                  <span className="w-red">
                                    ($
                                    {transactionHistory.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                                      2
                                    )}
                                    ){" "}
                                  </span>
                                </TableCell>
                                <TableCell className="w-text-right">
                                  <span className="w-red">
                                    ($
                                    {transactionHistory.priceBreakupDto.transferFee.toFixed(
                                      2
                                    )}
                                    ){" "}
                                  </span>
                                </TableCell>
                                <TableCell className="w-text-right">
                                  {transactionHistory.transferMode}
                                </TableCell>
                                <TableCell className="w-text-right">
                                  $
                                  {transactionHistory.priceBreakupDto.userAmount.toFixed(
                                    2
                                  )}
                                </TableCell>
                                <TableCell className="">
                                  {"Completed"}
                                </TableCell>
                                <TableCell className="w-text-right">
                                  {/* 08/27/2020  10:59AM */}
                                  {transactionHistory.amountTransferredDate}
                                </TableCell>
                                </>}
                              </TableRow>)
                            }
                          )}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              ) : (
                <div>
                  <h3 className="w-h3">Payment History</h3>{" "}
                  <p className="No-Payments-Yet">No Payments Yet</p>
                </div>
              )}
            </div>
            {/* :  */}
            {/* { this.state.transcardAccountState == false && walletBalance == 0
        ?
        <div className="You-can-link-your-ac">
        You can link your account once funds have been collected in a settlement.
        </div>
        : 
        ""
        } */}
            <div className="w-pby">
              <p>Powered by:</p>
              <img src={transcard} alt="" />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

Profile.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    data: state.data,
    recieveLinkAccountProfile: state.data.recieveLinkAccountProfile,
    recieveGetTranscardPaymentMethods:
      state.data.recieveGetTranscardPaymentMethods,
    recieveDisburseAmount: state.data.recieveDisburseAmount,
    receiveTransferFundsToACH: state.data.receiveTransferFundsToACH,
    receiveAddUserBankAccountApi: state.data.receiveAddUserBankAccountApi,
    receiveGetCollectedSettlementsHistoryForUser:
      state.data.receiveGetCollectedSettlementsHistoryForUser,
    receiveGetUserTransactionsHistory:
      state.data.receiveGetUserTransactionsHistory,
    receiveSetDefaultBankAccount: state.data.receiveSetDefaultBankAccount,
    receiveDeleteUserBankAccount: state.data.receiveDeleteUserBankAccount,
    receiveShowNetAmountToUser: state.data.receiveShowNetAmountToUser,
    receiveUpdateBankAccountDetails: state.data.receiveUpdateBankAccountDetails,
    receiveGetAddedBankAccountsForUser:
      state.data.receiveGetAddedBankAccountsForUser,
    receiveGetAllBankAccountsForUser:
      state.data.receiveGetAllBankAccountsForUser,
    receiveAddBusinessUserCard: state.data.receiveAddBusinessUserCard,
    receiveTranscardCardApi: state.data.receiveTranscardCardApi,
    receiveGetAddedCardsForUser: state.data.receiveGetAddedCardsForUser.data,
    receiveTransferFundsToCard: state.data.receiveTransferFundsToCard,
    receiveUpdateCardDetails: state.data.receiveUpdateCardDetails,
    receiveDeleteUserCard: state.data.receiveDeleteUserCard,
    receiveGetAllAddedCardsForUser: state.data.receiveGetAllAddedCardsForUser,
    receiveSetDefaultCard: state.data.receiveSetDefaultCard,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBusinessUser,
      getAllCountry,
      getCityByStateId,
      updateBusinessCompany,
      updateBusinessCompanyData,
      getAllStates,
      getBusiness,
      viewCompanyChildRecord,
      deleteCompanyChildRecord,
      getIndustry,
      updateBusinessUser,
      uploadfile,
      getAllChildCompanyProfile,
      postUploadChildCompany,
      getAllBusinessSubUsers,
      checkEmailVerify,
      clearDataEmail,
      getDebitWalletBalance,
      createTranscardAccount,
      addUserBankAccount,
      getTranscardPaymentMethods,
      disbursePayment,
      transferFundsToACH,
      transferFundsToCard,
      clearReceiveAddUserBankAccountApi,
      getAddedBankAccountsForUser,
      getCollectedSettlementsHistoryForUser,
      getAllBankAccountsForUser,
      setDefaultBankAccount,
      deleteUserBankAccount,
      showNetAmountToUser,
      updateBankAccountDetails,
      clearReceiveTransferFundsToACH,
      cleargetDebitWalletBalance,
      updateBankAccountDetails,
      clearRecieveDisburseAmount,
      getUserTransactionsHistory,
      createTranscardCard,
      addBusinessUserCard,
      clearReceiveAddBusinessUserCard,
      clearReceiveUpdateBankAccountDetails,
      clearReceiveUpdateCardDetails,
      getAddedCardsForUser,
      updateCardDetails,
      deleteUserCard,
      getAllAddedCardsForUser,
      setDefaultCard,
    },
    dispatch
  );

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(Profile));
